<template>
	<div>
		<!-- 头部 -->
		<div class="z-[105] fixed insetsScroll top-0 w-full" id="header">
			<!-- 已登录 -->
			<div class="mp-topbar pl-[10px] bg-[#000b1d] items-center h-[52px] lg:h-[72px]
		       flex justify-between py-[5px] lg:pr-0 lg:pl-0" v-if="token && info.name">
				<!-- mobile logged-in header -->
				<div class="flex lg:hidden items-center justify-between w-full pr-[10px]">
					<button type="button" class="mp-menu-btn" @click="toggleLeft" aria-label="menu">
						<span></span><span></span><span></span>
					</button>
					<div class="mp-brand" @click="goNextPage('/')">
						<img v-if="siteLogoUrl" class="mp-brand__logo" :src="siteLogoUrl" :alt="siteName" />
					</div>
					<div class="mp-balance-pill" @click="goNextPage('/deposit')">
						<svg class="mp-balance-pill__coin" viewBox="0 0 32 32" aria-hidden="true">
							<circle cx="16" cy="16" r="15" fill="#f59e0b"/>
							<circle cx="16" cy="16" r="12.5" fill="#fbbf24"/>
							<circle cx="16" cy="16" r="10" fill="none" stroke="#d97706" stroke-width="1.4"/>
							<text x="16" y="20.5" text-anchor="middle" font-size="12" font-weight="800" fill="#92400e" font-family="Arial,sans-serif">$</text>
						</svg>
						<span class="mp-balance-pill__amt">{{ info.money || 0 }}</span>
						<button type="button" class="mp-balance-pill__refresh" @click.stop="getrefresh" aria-label="refresh">
							<i class="mdi-refresh mdi v-icon notranslate v-theme--light" :class="{ 'rotate-spin': isRotating }" aria-hidden="true"></i>
						</button>
					</div>
					<button type="button" class="mp-flag-btn" @click="changelang" aria-label="language">
						<img :src="currentLangFlag" alt="" />
					</button>
				</div>
				<!-- pc logged-in：截图布局（蓝主题） -->
				<div class="mp-topbar__inner hidden lg:flex">
					<div class="mp-pc-left">
						<button type="button" class="mp-pc-brand" @click="goNextPage('/')">
							<img v-if="siteLogoUrl" class="mp-pc-brand__logo" :src="siteLogoUrl" :alt="siteName" />
						</button>
						<nav class="mp-pc-nav" aria-label="main">
							<button
								type="button"
								class="mp-pc-nav__item"
								:class="{ 'is-active': isPcNavActive('/') }"
								@click="goNextPage('/')"
							>
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 3.2 3.5 10.2V21h6.2v-5.4h4.6V21h6.2V10.2L12 3.2z"/></svg>
								<span>{{ $t('indexTitle.title273') }}</span>
							</button>
							<button
								type="button"
								class="mp-pc-nav__item"
								:class="{ 'is-active': isPcNavActive('/promotions') }"
								@click="goNextPage('/promotions')"
							>
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 3.2 9.8 8.4 4.2 9l4.2 3.8-1.2 5.4L12 15.8l4.8 2.4-1.2-5.4L20 9l-5.6-.6L12 3.2z"/></svg>
								<span>{{ $t('indexTitle.title274') }}</span>
							</button>
							<!-- PC「赚钱」先隐藏
							<button
								type="button"
								class="mp-pc-nav__item"
								:class="{ 'is-active': isPcNavActive('/vipRebates') }"
								@click="goNextPage('/vipRebates')"
							>
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7.2 4.5h9.6l1.7 3.4-6.5 7.4-6.5-7.4 1.7-3.4zm2.1 1.6L7.8 8h8.4l-1.5-1.9H9.3zM5 20.2V12l7 7.8 7-7.8v8.2H5z"/></svg>
								<span>{{ $t('indexTitle.title275') }}</span>
							</button>
							-->
							<button
								type="button"
								class="mp-pc-nav__item"
								:class="{ 'is-active': isPcNavActive('/invite') }"
								@click="goNextPage('/invite')"
							>
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9.2 11.2a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2zm7.1-.4a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM3.5 18.8c0-2.7 2.4-4.6 5.7-4.6s5.7 1.9 5.7 4.6v.7H3.5v-.7zm10.4-.2c.4-1.1 1.3-2 2.4-2.5.7-.3 1.5-.5 2.4-.5 2.5 0 4.3 1.4 4.3 3.5v.7h-9.1v-1.2z"/></svg>
								<span>{{ $t('indexTitle.title28') }}</span>
							</button>
							<button type="button" class="mp-pc-nav__item" @click="getKefu">
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.2 3.5h11.6c1 0 1.7.8 1.7 1.7v13.6l-3.4-2.2H6.2c-1 0-1.7-.8-1.7-1.7V5.2c0-1 .8-1.7 1.7-1.7zm1.5 4.2v1.6h8.6V7.7H7.7zm0 3.4v1.6h6.2v-1.6H7.7z"/></svg>
								<span>{{ $t('indexTitle.title210') }}</span>
							</button>
						</nav>
					</div>
					<div class="mp-pc-right">
						<button type="button" class="mp-pc-flag" @click="changelang" aria-label="language">
							<img :src="currentLangFlag" alt="" />
						</button>
						<div class="mp-pc-balance">
							<svg class="mp-pc-balance__coin" viewBox="0 0 32 32" aria-hidden="true">
								<circle cx="16" cy="16" r="15" fill="#f59e0b"/>
								<circle cx="16" cy="16" r="12.5" fill="#fbbf24"/>
								<circle cx="16" cy="16" r="10" fill="none" stroke="#d97706" stroke-width="1.4"/>
								<text x="16" y="20.5" text-anchor="middle" font-size="12" font-weight="800" fill="#92400e" font-family="Arial,sans-serif">$</text>
							</svg>
							<span class="mp-pc-balance__amt">{{ info.money || 0 }}</span>
							<button type="button" class="mp-pc-balance__refresh" @click="getrefresh" aria-label="refresh">
								<i class="mdi-refresh mdi v-icon notranslate v-theme--light v-icon--size-default text-white"
									aria-hidden="true" :class="{ 'rotate-spin': isRotating }"></i>
							</button>
						</div>
						<button type="button" class="mp-pc-btn mp-pc-btn--deposit" @click="goNextPage('/deposit')">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5v9.2m0 0 3.2-3.2M12 12.7 8.8 9.5M5.5 15.2v2.3c0 1 .8 1.8 1.8 1.8h9.4c1 0 1.8-.8 1.8-1.8v-2.3" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
							<span>{{ $t('indexTitle.title4') || $t('indexTitle.title26') }}</span>
						</button>
						<button type="button" class="mp-pc-btn mp-pc-btn--withdraw" @click="goNextPage('/withdraw')">
							<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5V11.3m0 0 3.2 3.2M12 11.3 8.8 14.5M5.5 8.8V6.5c0-1 .8-1.8 1.8-1.8h9.4c1 0 1.8.8 1.8 1.8v2.3" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
							<span>{{ $t('indexTitle.title5') }}</span>
						</button>
						<div class="mp-pc-menu-wrap relative">
							<button type="button" class="mp-pc-hamburger" @click="openPcSideMenu" aria-label="menu">
								<span></span><span></span><span></span>
							</button>
							<!-- 旧下拉菜单保留但不再由汉堡打开；改由左侧滑出抽屉 -->
							<div v-if="false && mineshow"
								class="absolute h-full lg:h-auto top-[0px] lg:top-[48px] right-0 z-10 lg:bg-[#0a162b] bg-[#202020] scrollableHidden overflow-y-auto lg:border-[rgba(63,170,252,0.25)] lg:!border lg:rounded-lg w-full lg:w-[300px]" style="width:350px;">
								<div class="flex relative flex-col px-[20px] pt-[15px] pb-[25px] max-h-[90vh]">
									<div class="mb-[15px] py-[10px] pl-[10px] rounded-lg flex">
										<div><img data-nuxt-img="" class="size-[45px] rounded-[50%]"
												src="@/assets/newimg/photo_v.webp"></div>
										<div class="pl-[10px] flex flex-col justify-center text-white">
											<div>{{ info.name }}</div>
											<div>{{ info.money || 0 }}</div>
										</div>
									</div>
									<div class="flex flex-col pb-[15px]" @click="goNextPage('/vip')">
										<div class="flex justify-between pl-[10px] pb-[10px]">
											<div
												class="w-full cursor-pointer flex text-[white] justify-between items-center">
												<div class="text-[white] text-[14px]">{{ info.level_name }}</div><i
													class="mdi-chevron-right mdi v-icon notranslate v-theme--light v-icon--size-default pb-[3px]"
													aria-hidden="true"></i>
											</div>
										</div>
										<el-progress :percentage="info.next_level_point" class="custom-circle-progress"
											:text-inside="true"></el-progress>
									</div>
									<div class="feature-entries mb-[15px] grid grid-cols-2 gap-[10px]">
										<div class="feature-card feature-card--bonus" @click="goNextPage('/bonusPool')">
											<div class="feature-card__glow"></div>
											<div class="feature-card__body">
												<div class="feature-card__icon feature-card__icon--bonus">
													<img src="@/assets/newimg/gift.svg" alt="">
												</div>
												<div class="feature-card__text">
													<div class="feature-card__title">{{ $t('indexTitle.title531') }}</div>
													<div class="feature-card__desc">{{ $t('indexTitle.title533') }}</div>
												</div>
												<svg class="feature-card__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
													<path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
												</svg>
											</div>
										</div>
										<div class="feature-card feature-card--yuebao" @click="goNextPage('/yuebao')">
											<div class="feature-card__glow"></div>
											<div class="feature-card__body">
												<div class="feature-card__icon feature-card__icon--yuebao">
													<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12 2L4 6v6c0 5.25 3.4 10.15 8 11.35 4.6-1.2 8-6.1 8-11.35V6l-8-4z" fill="currentColor" opacity="0.25"/>
														<path d="M12 7v10M9 10h6M9 14h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
													</svg>
												</div>
												<div class="feature-card__text">
													<div class="feature-card__title">{{ $t('indexTitle.title532') }}</div>
													<div class="feature-card__desc">{{ $t('indexTitle.title534') }}</div>
												</div>
												<svg class="feature-card__arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
													<path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
												</svg>
											</div>
										</div>
									</div>
									<div @click="goNextPage('/profile')"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title123') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="personalMsg()"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title33') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="goNextPage('/deposit')"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title4') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="goNextPage('/withdraw')"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title5') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="goNextPage('/game-historyTow')"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title31') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="goNextPage('/promotion')"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title32') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="goNextPage('/mywallet')"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title125') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="goNextPage('/bankcards')"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title233') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="goNextPage('/vipRebates')"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title45') }}</span></div>
											</div>
										</div>
									</div>

									<div @click="changelang"
										class="hover:bg-[#6b6b6b] min-h-[35px] hover:text-white $-font-[600] duration-300 cursor-pointer h-[35px] rounded-lg text-[white] lg:!text-[#7e7e7e] flex items-center lg:px-[10px] mb-[10px]">
										<div class="flex justify-between w-full items-center">
											<div class="flex justify-center items-center">
												<div class="pl-[10px] text-[14px]">
													<span>{{ $t('indexTitle.title353') }}</span></div>
											</div>
										</div>
									</div>
									<div @click="loginOut"
										class="pt-[5px] cursor-pointer flex text-[#4dfefe] pb-[30px] $-font-[600] w-full justify-center">
										<i class="mdi-logout mdi v-icon notranslate v-theme--light v-icon--size-default"
											aria-hidden="true"
											style="color: rgb(77, 254, 254); caret-color: rgb(77, 254, 254);"></i>
										{{ $t('indexTitle.title212') }}
									</div>
								</div>
							</div>
							<!--菜单栏结束-->
						</div>
					</div>
				</div><!-- /.mp-topbar__inner -->
			</div>
			<!-- 已登陆结束 -->
			<!-- 未登录：移动端按截图顶栏；PC 同视觉布局 -->
			<div class="mp-topbar-guest px-[12px] bg-[#000b1d] items-center h-[52px] lg:h-[72px]
			       flex justify-between py-[5px] lg:pr-0 lg:pl-0" v-if="!token || !info.name">
				<!-- mobile -->
				<div class="flex lg:hidden items-center justify-between w-full">
					<button type="button" class="mp-menu-btn" @click="toggleLeft" aria-label="menu">
						<span></span><span></span><span></span>
					</button>
					<div class="mp-brand" @click="goNextPage('/')">
						<img v-if="siteLogoUrl" class="mp-brand__logo" :src="siteLogoUrl" :alt="siteName" />
					</div>
					<button type="button" class="mp-flag-btn" @click="changelang" aria-label="language">
						<img :src="currentLangFlag" alt="" />
					</button>
				</div>
				<!-- pc：截图布局 + 登录注册 -->
				<div class="mp-topbar__inner hidden lg:flex" v-if="!$appData || !$appData.isMobile">
					<div class="mp-pc-left">
						<button type="button" class="mp-pc-brand" @click="goNextPage('/')">
							<img v-if="siteLogoUrl" class="mp-pc-brand__logo" :src="siteLogoUrl" :alt="siteName" />
						</button>
						<nav class="mp-pc-nav" aria-label="main">
							<button type="button" class="mp-pc-nav__item" :class="{ 'is-active': isPcNavActive('/') }" @click="goNextPage('/')">
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 3.2 3.5 10.2V21h6.2v-5.4h4.6V21h6.2V10.2L12 3.2z"/></svg>
								<span>{{ $t('indexTitle.title273') }}</span>
							</button>
							<button type="button" class="mp-pc-nav__item" :class="{ 'is-active': isPcNavActive('/promotions') }" @click="goNextPage('/promotions')">
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 3.2 9.8 8.4 4.2 9l4.2 3.8-1.2 5.4L12 15.8l4.8 2.4-1.2-5.4L20 9l-5.6-.6L12 3.2z"/></svg>
								<span>{{ $t('indexTitle.title274') }}</span>
							</button>
							<!-- PC「赚钱」先隐藏
							<button type="button" class="mp-pc-nav__item" :class="{ 'is-active': isPcNavActive('/vipRebates') }" @click="goNextPage('/vipRebates')">
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7.2 4.5h9.6l1.7 3.4-6.5 7.4-6.5-7.4 1.7-3.4zm2.1 1.6L7.8 8h8.4l-1.5-1.9H9.3zM5 20.2V12l7 7.8 7-7.8v8.2H5z"/></svg>
								<span>{{ $t('indexTitle.title275') }}</span>
							</button>
							-->
							<button type="button" class="mp-pc-nav__item" :class="{ 'is-active': isPcNavActive('/invite') }" @click="goNextPage('/invite')">
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9.2 11.2a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2zm7.1-.4a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM3.5 18.8c0-2.7 2.4-4.6 5.7-4.6s5.7 1.9 5.7 4.6v.7H3.5v-.7zm10.4-.2c.4-1.1 1.3-2 2.4-2.5.7-.3 1.5-.5 2.4-.5 2.5 0 4.3 1.4 4.3 3.5v.7h-9.1v-1.2z"/></svg>
								<span>{{ $t('indexTitle.title28') }}</span>
							</button>
							<button type="button" class="mp-pc-nav__item" @click="getKefu">
								<svg class="mp-pc-nav__ico" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.2 3.5h11.6c1 0 1.7.8 1.7 1.7v13.6l-3.4-2.2H6.2c-1 0-1.7-.8-1.7-1.7V5.2c0-1 .8-1.7 1.7-1.7zm1.5 4.2v1.6h8.6V7.7H7.7zm0 3.4v1.6h6.2v-1.6H7.7z"/></svg>
								<span>{{ $t('indexTitle.title210') }}</span>
							</button>
						</nav>
					</div>
					<div class="mp-pc-right">
						<button type="button" class="mp-pc-flag" @click="changelang" aria-label="language">
							<img :src="currentLangFlag" alt="" />
						</button>
						<button type="button" class="mp-pc-btn mp-pc-btn--ghost" @click="$router.push('/login')">
							{{ $t('indexTitle.title2') }}
						</button>
						<button type="button" class="mp-pc-btn mp-pc-btn--deposit" @click="$router.push('/register')">
							{{ $t('indexTitle.title1') }}
						</button>
						<button type="button" class="mp-pc-hamburger" @click="toggleLeft" aria-label="menu">
							<span></span><span></span><span></span>
						</button>
					</div>
				</div>
			</div>
			<!-- 未登录结束 -->
		</div>
		<!-- 头部结束 -->
		<!-- 客服 -->
		<el-dialog :visible.sync="kefushow" center width="360px">
			<div class="w-full rounded-lg flex flex-col justify- text-white">
				<img data-nuxt-img="" src="@/assets/newimg/service_bg_v2.webp">
				<div class="bg-[#1c1c1c] py-5 px-3 rounded-lg mt-[20px]">
					<div class="pb-[10px] $-font-[600] text-[14px] lg:text-[16px]">{{ $t('indexTitle.title304') }}</div>
					<div class="flex cursor-pointer mb-[10px] rounded-md items-center p-[10px] justify-between"
						@click="kefu(1)" style="background:rgb(38 38 38/var(--tw-bg-opacity,1))">
						<div class="flex items-center"><img data-nuxt-img="" class="size-[24px] mr-[10px] object-contain"
								:src="siteLogoUrl" alt="">
							<div class="text-[14px] lg:text-[16px] $-font-[600]">{{ $t('indexTitle.title344') }}</div>
						</div>
						<div><i class="mdi-chevron-right mdi v-icon notranslate v-theme--light v-icon--size-default"
								aria-hidden="true"></i></div>
					</div>
					<div class="flex cursor-pointer mb-[10px] rounded-md items-center p-[10px] justify-between"
						@click="kefu(2)" style="background:rgb(38 38 38/var(--tw-bg-opacity,1))">
						<div class="flex items-center"><img data-nuxt-img="" class="size-[24px] mr-[10px] object-contain"
								:src="siteLogoUrl" alt="">
							<div class="text-[14px] lg:text-[16px] $-font-[600]">{{ $t('indexTitle.title345') }}</div>
						</div>
						<div><i class="mdi-chevron-right mdi v-icon notranslate v-theme--light v-icon--size-default"
								aria-hidden="true"></i></div>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 客服结束 -->
		
		<!-- 登陆 -->
		<div v-if="$appData.isMobile">
			<el-dialog :visible.sync="loginShow" center width="380px">
				<img data-nuxt-img="" class="rounded-l-[6px] lg:block hidden w-[430px]" 
					src="@/assets/newimg/login_banner_v.webp">
				<div class="text-white flex flex-col items-center w-full lg:w-[calc(100%-430px)]" style="margin-top: -60px;">
					<img data-nuxt-img=""
						class="w-[150px] mt-[20px]" src="@/assets/newimg/wgclub_logo.webp">
					<div class="text-[18px] font-bold text-white mt-[10px]">{{ $t('indexTitle.title2') }}</div>
					<div class="flex justify-center w-full pt-[15px]">
						<div class="flex bg-[#353535] rounded-lg p-[3px]">
							<div class="px-[25px] py-[6px] rounded-md text-[14px] cursor-pointer"
								:class="loginTab == 0 ? 'bg-gradient-to-b from-[#00EEFF] to-[#00DDB8] text-black' : 'text-white'"
								@click="loginTab = 0; isShowThreess = false;loginisShowPhoness = false;">
								{{ $t('indexTitle.title489') }}
							</div>
							<div class="px-[25px] py-[6px] rounded-md text-[14px] cursor-pointer"
								:class="loginTab == 1 ? 'bg-gradient-to-b from-[#00EEFF] to-[#00DDB8] text-black' : 'text-white'"
								@click="loginTab = 1; isShowThreess = false;loginisShowPhoness = false;">
								{{ $t('indexTitle.title490') }}
							</div>
						</div>
					</div>

					<div class="flex w-full flex-col items-center lg:px-[135px] pt-[20px] lg:pt-[40px]">
						<form class="flex flex-col w-full " data-gtm-form-interact-id="0">
							<div v-show="loginTab == 1" class="flex flex-col pb-[10px] relative">
								<div class="">
									<div class="flex">
										<div 
											class="bg-[#353535] select-root flex items-center relative justify-between min-w-[110px] max-w-[110px] rounded-[4px] h-[40px] !text-theme-text-muted !bg-theme-bg-secondary mr-[5px] !min-w-[110px]">
											<div  class="w-full text-[14px] cursor-pointer h-full flex items-center pr-1 overflow-hidden">
												<div 
													class="!text-[16px] pl-[15px] overflow-hidden text-ellipsis whitespace-nowrap common_select-title">+852 香港
												</div>
											</div>
										</div>
										<input
											class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
											:placeholder="$t('indexTitle.title484')" type="tel" v-model="loginphone"
											maxlength="20">
									</div>
									<div class="absolute left-[2px] top-[10%]"></div>
									<div v-if="loginisShowPhoness && !isShowThreess"
										class="peer-focus:visible bottom-[51px] bg-[#1a1c20]  absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
										<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
												aria-hidden="true"
												style="font-size: 15px; height: 15px; width: 15px;"></i><span
												class="text-[14px] pl-[5px] !text-[gray]">{{ loginphonesamll }}</span>
										</div>
									</div>
								</div>
							</div>
							<div v-show="loginTab == 0" class="flex flex-col pb-[10px] relative">
								<div class=""><input
										class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
										:placeholder="$t('indexTitle.title192')" type="text" v-model="name"
										data-gtm-form-interact-field-id="0">
									<div class="absolute left-[2px] top-[10%]"></div>
									<!-- 正确提示 -->
									<!-- <div v-if="isShowOness&&!isShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20] invisible absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded border-[#41ebe2]">
											<div>
												<i class="mdi-check-all mdi v-icon notranslate v-theme--light pb-[3px]"
													aria-hidden="true"
													style="font-size: 15px; height: 15px; width: 15px; color: rgb(65, 235, 226); caret-color: rgb(65, 235, 226);"></i><span
													class="text-[12px] pl-[5px] !text-[#41ebe2]">请输入用户名</span>
											</div> -->
								</div>
								<!-- 错误提示 -->
								<div v-if="isShowOness && !isShowThreess"
									class="peer-focus:visible bottom-[51px] bg-[#1a1c20]  absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
									<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
											aria-hidden="true"
											style="font-size: 15px; height: 15px; width: 15px;"></i><span
											class="text-[14px] pl-[5px] !text-[gray]">{{ namesmall }}</span></div>
								</div>
								<div v-if="!isShowOness && isShowThreess"
									class="peer-focus:visible bottom-[51px] bg-[#1a1c20]  absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
									<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
											aria-hidden="true"
											style="font-size: 15px; height: 15px; width: 15px;"></i><span
											class="text-[14px] pl-[5px] !text-[gray]">{{ messageText }}</span>
									</div>
									<!-- 错误提示 -->
								</div>
							</div>
							<div class="flex flex-col pb-[10px] relative">
								<div class=""><input
										class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
										:placeholder="$t('indexTitle.title193')" :type="passwordtype" v-model="password"
										data-gtm-form-interact-field-id="1">
									<div class="absolute left-[2px] top-[10%]"></div>
									<!-- 错误提示 -->
									<div v-if="isShowTowss && !isShowThreess"
										class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
										<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
												aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
												class="text-[14px] pl-[5px] !text-[gray]">{{ psdsamll }}</span></div>
									</div>
									<!-- <div v-if="!isShowTowss&&isShowThreess"
													class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
													<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
															aria-hidden="true"
															style="font-size: 15px; height: 15px; width: 15px;"></i><span
															class="text-[14px] pl-[5px] !text-[gray]">{{messageText}}</span>
													</div> -->
								</div>
								<div class="absolute right-[10px] top-[7px] cursor-pointer">
									<img class="size-[20px]" src="@/assets/newimg/eye_invisible.svg"
										@click="passwordtype = 'text'" v-if="passwordtype == 'password'">
									<img class="size-[20px]" src="@/assets/newimg/eye_visible.svg"
										@click="passwordtype = 'password'" v-if="passwordtype == 'text'">
								</div>
							</div>
							<div class="  pt-[10px] text-white text-[14px]">
								<div class="h-full items-center" style="float:left;">
									<el-checkbox v-model="activitId">{{ $t('indexTitle.title435') }}</el-checkbox>
								</div>
								<div class="h-full items-center" style="float:right;" @click="forgotShow = true;loginShow=false">
									<span class="cursor-pointer pl-[5px] $-font-[600]">{{ $t('indexTitle.title196') }} ? </span>
								</div>
							</div>
								<!-- <div class="flex justify-center pb-[15px]" v-if="hcaptchaSitekey">
									<vue-hcaptcha ref="hcaptchaMobile" :sitekey="hcaptchaSitekey"
										@verify="hcaptchaToken = $event"
										@error="hcaptchaToken = ''">
									</vue-hcaptcha>
								</div> -->
							<div class="relative mt-[15px]">
								<div class="top-0 w-full flex justify-center items-center text-black">
									<el-button type="primary" :loading="isloadingTowShow" @click="handleLoginClick()"
										class="h-[40px] text-[16px] $-font-[600] w-full flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
										{{ $t('indexTitle.title2') }}
									</el-button>

								</div>
							</div>
						</form>
					</div>
					<div class="lg:w-[500px]">
						<div class="pt-[20px] z-[1] text-[14px] text-[#aba9a9] font-medium flex justify-between items-center">
							<div class="flex justify-center w-full px-[10px]"><span class="text-white">{{ $t('indexTitle.title1') }}
									WGCLUB
									发现更多精彩内容</span><span class="pl-[10px] text-[#41ebe2] cursor-pointer $-font-[600]"
									@click="loginShow = false; registerShow = true"><span>{{ $t('indexTitle.title1') }}</span><span>{{ $t('indexTitle.title192') }}</span></span>
							</div>
						</div>
					</div>	
				</div>
			</el-dialog>
		</div>
		<div class="flex justify-center items-center vfm vfm--fixed vfm--inset" role="dialog" aria-modal="true"
			style="z-index: 1000;" v-if="loginShow && !$appData.isMobile">
			<div class="vfm__overlay vfm--overlay vfm--absolute vfm--inset vfm--prevent-none" aria-hidden="true"></div>
			<div class="vfm__content vfm--outline-none w-[calc(100%-20px)] lg:w-[1050px] pb-[20px] bg-[#1c1c1c] relative flex items-center justify-center rounded-lg"
				tabindex="0">
				<div class="flex w-full min-h-[547px] lg:min-h-[600px] max-h-[650px] overflow-y-auto h-full relative rounded-xl"
					style="min-height: 374px;">
					<div class="absolute right-4 top-6 cursor-pointer" @click="loginShow = false"><i
							class="mdi-close-circle-outline mdi v-icon notranslate v-theme--light text-white"
							aria-hidden="true" style="font-size: 28px; height: 28px; width: 28px;"></i></div><img
						data-nuxt-img="" class="rounded-l-[6px] lg:block hidden w-[430px]"
						src="@/assets/newimg/login_banner_v.webp">
					<div class="text-white flex flex-col items-center w-full lg:w-[calc(100%-430px)]"><img data-nuxt-img=""
							class="w-[150px] mt-[20px]" src="@/assets/newimg/wgclub_logo.webp">
						<div class="$-font-[600] pt-[10px] lg:pt-[15px] text-[20px]">{{ $t('indexTitle.title2') }}</div>

						<div class="flex w-full flex-col items-center lg:px-[135px] pt-[20px] lg:pt-[40px]">
							<form class="flex flex-col w-full px-[20px] lg:px-[10px]" data-gtm-form-interact-id="0">
								<div class="flex justify-center w-full pb-[15px]">
									<div class="flex bg-[#353535] rounded-lg p-[3px]">
										<div class="px-[25px] py-[6px] rounded-md text-[14px] cursor-pointer"
											:class="loginTab == 0 ? 'bg-gradient-to-b from-[#00EEFF] to-[#00DDB8] text-black' : 'text-white'"
											@click="loginTab = 0; ">
											{{ $t('indexTitle.title489') }}
										</div>
										<div class="px-[25px] py-[6px] rounded-md text-[14px] cursor-pointer"
											:class="loginTab == 1 ? 'bg-gradient-to-b from-[#00EEFF] to-[#00DDB8] text-black' : 'text-white'"
											@click="loginTab = 1; ">
											{{ $t('indexTitle.title490') }}
										</div>
									</div>
								</div>
								<div v-show="loginTab == 1" class="flex flex-col pb-[10px] relative">
									<div class="">
										<div class="flex">
											<div 
												class="bg-[#353535] select-root flex items-center relative justify-between min-w-[110px] max-w-[110px] rounded-[4px] h-[40px] !text-theme-text-muted !bg-theme-bg-secondary mr-[5px] !min-w-[110px]">
												<div  class="w-full text-[14px] cursor-pointer h-full flex items-center pr-1 overflow-hidden">
													<div 
														class="!text-[16px] pl-[15px] overflow-hidden text-ellipsis whitespace-nowrap common_select-title">+852 香港
													</div>
												</div>
											</div>
											<input
												class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
												:placeholder="$t('indexTitle.title484')" type="tel" v-model="loginphone"
												maxlength="20">
										</div>
										<div class="absolute left-[2px] top-[10%]"></div>
										<div v-if="loginisShowPhoness && !isShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20]  absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true"
													style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ loginphonesamll }}</span>
											</div>
										</div>
									</div>
								</div>
								<div v-show="loginTab == 0" class="flex flex-col pb-[10px] relative">
									<div class=""><input
											class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
											:placeholder="$t('indexTitle.title192')" type="text" v-model="name"
											data-gtm-form-interact-field-id="0">
										<div class="absolute left-[2px] top-[10%]"></div>
										<!-- 错误提示 -->
										<div v-if="isShowOness && !isShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20]  absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true"
													style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ namesmall }}</span></div>
										</div>
										<div v-if="!isShowOness && isShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20]  absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true"
													style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ messageText }}</span>
											</div>
											<!-- 错误提示 -->
										</div>
									</div>
								</div>
								<div class="flex flex-col pb-[10px] relative">
									<div class=""><input
											class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
											:placeholder="$t('indexTitle.title193')" :type="passwordtype" v-model="password"
											data-gtm-form-interact-field-id="1">
										<div class="absolute left-[2px] top-[10%]"></div>
										<!-- 错误提示 -->
										<div v-if="isShowTowss && !isShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true"
													style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ psdsamll }}</span></div>
										</div>
										<!-- <div v-if="!isShowTowss&&isShowThreess"
												class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
												<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
														aria-hidden="true"
														style="font-size: 15px; height: 15px; width: 15px;"></i><span
														class="text-[14px] pl-[5px] !text-[gray]">{{messageText}}</span>
												</div> -->
									</div>
									<div class="absolute right-[10px] top-[7px] cursor-pointer">
										<img class="size-[20px]" src="@/assets/newimg/eye_invisible.svg"
											@click="passwordtype = 'text'" v-if="passwordtype == 'password'">
										<img class="size-[20px]" src="@/assets/newimg/eye_visible.svg"
											@click="passwordtype = 'password'" v-if="passwordtype == 'text'">
									</div>
								</div>
								<div class="  pt-[10px] text-white text-[14px]">
									<div class="h-full items-center" style="float:left;">
										<el-checkbox v-model="activitId">{{ $t('indexTitle.title435') }}</el-checkbox>
									</div>
									<div class="h-full items-center" style="float:right;" @click="forgotShow = true; loginShow = false">
										<span class="cursor-pointer pl-[5px] $-font-[600]">{{ $t('indexTitle.title196') }} ? </span>
									</div>
								</div>
								
								<div class="relative mt-[15px]">
									<div class="top-0 w-full flex justify-center items-center text-black"><button @click="handleLoginClick()"
											type="button"
											class="h-[40px] text-[16px] $-font-[600] w-full flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
											{{ $t('indexTitle.title2') }}</button></div>
								</div>
							</form>
						</div>
						<div class="lg:w-[500px]">
							<div
								class="pt-[20px] z-[1] text-[14px] text-[#aba9a9] font-medium flex justify-between items-center">
								<div class="flex justify-center w-full px-[10px]"><span
										class="text-white">{{ $t('indexTitle.title1') }} WGCLUB
										发现更多精彩内容</span><span class="pl-[10px] text-[#41ebe2] cursor-pointer $-font-[600]"
										@click="loginShow = false; registerShow = true"><span>{{ $t('indexTitle.title1') }}</span><span>{{ $t('indexTitle.title192') }}</span></span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 登陆结束 -->
		
		<!-- 注册 -->
		<div v-if="$appData.isMobile">
			<el-dialog :visible.sync="registerShow" center width="380px"
				style="margin-top: -5vh;">
				<img data-nuxt-img="" class="rounded-l-[6px] lg:block hidden w-[430px]"
					src="@/assets/newimg/login_banner_v.webp">
				<div class="text-white flex flex-col items-center w-full lg:w-[calc(100%-430px)]" style="margin-top: -60px;"><img data-nuxt-img=""
						class="w-[150px] mt-[15px]" src="@/assets/newimg/wgclub_logo.webp">
					<div class="text-[18px] font-bold text-white mt-[10px]">{{ $t('indexTitle.title1') }}</div>
					<!-- <div class="$-font-[600] text-[20px]">注册</div> -->
					<div class="flex w-full flex-col items-center lg:px-[105px] pt-[20px]">
						<form class="flex flex-col w-full" data-gtm-form-interact-id="2">
							<div>
								<div class="flex flex-col relative pb-[10px]">
									<div><input type="text"
											class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
											v-model="registername" maxlength="12" minlength="6"
											:placeholder="$t('indexTitle.title481')" data-gtm-form-interact-field-id="4">
										<div class="absolute left-[2px] bottom-[10px]"></div>
										<!-- 错误提示 -->
										<div v-if="registerisShowOness && !registerisShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true"
													style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ registernamesmall }}</span>
											</div>
										</div>
										<div v-if="!registerisShowOness && registerisShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true"
													style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ registermessageText }}</span>
											</div>
											<!-- 错误提示 -->
										</div>
									</div>
								</div>
								<div class="pb-[10px] flex flex-col relative">
									<div><input autocomplete="new-password" name="new-password"
											class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
											:type="registerPasswordType" v-model="registerpassword" maxlength="16" 
											:placeholder="$t('indexTitle.title482')" data-gtm-form-interact-field-id="5">
										<div class="absolute left-[2px] bottom-[10px]"></div>
										<!-- 错误提示 -->
										<div v-if="registerisShowTowss && !registerisShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true"
													style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ registerpsdsamll }}</span>
											</div>
										</div>
										<!-- <div v-if="!registerisShowTowss&&registerisShowThreess"
													class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
													<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
															aria-hidden="true"
															style="font-size: 15px; height: 15px; width: 15px;"></i><span
															class="text-[14px] pl-[5px] !text-[gray]">{{registermessageText}}</span>
													</div> -->
									</div>

									<div class="absolute right-[10px]  cursor-pointer" style="top:10px;">
										<img class="size-[20px]" src="@/assets/newimg/eye_invisible.svg"
											@click="registerPasswordType = 'text'"
											v-if="registerPasswordType == 'password'">
										<img class="size-[20px]" src="@/assets/newimg/eye_visible.svg"
											@click="registerPasswordType = 'password'"
											v-if="registerPasswordType == 'text'">
									</div>

								</div>
								<div class="pb-[10px] flex flex-col relative">
								<div><input type="text"
										class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
										v-model="registerrealname" maxlength="32" :placeholder="$t('indexTitle.title483')"
										data-gtm-form-interact-field-id="4">
									<div class="absolute left-[2px] bottom-[10px]"></div>
									<!-- 错误提示 -->
									<div v-if="registerisShowfivess && !registerisShowThreess"
										class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
										<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
												aria-hidden="true"
												style="font-size: 15px; height: 15px; width: 15px;"></i><span
												class="text-[14px] pl-[5px] !text-[gray]">{{ registerrealnamesmall }}</span>
										</div>
									</div>
									<!-- <div v-if="!registerisShowfivess&&registerisShowThreess"
													class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
													<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
															aria-hidden="true"
															style="font-size: 15px; height: 15px; width: 15px;"></i><span
															class="text-[14px] pl-[5px] !text-[gray]">{{registermessageText}}</span>
													</div> -->
								</div>
								</div>
								<div class="pb-[10px] flex flex-col relative">
									<div>
										<div class="flex">
											<div 
												class="bg-[#353535] select-root flex items-center relative justify-between min-w-[110px] max-w-[110px] rounded-[4px] h-[40px] !text-theme-text-muted !bg-theme-bg-secondary mr-[5px] !min-w-[110px]">
												<div  class="w-full text-[14px] cursor-pointer h-full flex items-center pr-1 overflow-hidden">
													<div 
														class="!text-[16px] pl-[15px] overflow-hidden text-ellipsis whitespace-nowrap common_select-title">+852 香港
													</div>
												</div>
											</div>
											<input
												class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
												v-model="registerphone"  type="tel" :placeholder="$t('indexTitle.title484')"
												maxlength="20">
										</div>
										<div class="absolute left-[2px] bottom-[10px]"></div>
										<!-- 错误提示 -->
										<div v-if="registerisShowFourss && !registerisShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ registerphonesamll }}</span>
											</div>
										</div>

									</div>
								</div>
								<div class="pb-[10px] flex flex-col relative">
									<div class="flex justify-between">
										<div class="w-[65%]"><input
												class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
												v-model="registercode" maxlength="6" :placeholder="$t('indexTitle.title487')" inputmode="numeric"  pattern="[0-9]*" autocomplete="one-time-code">
										</div>
										<el-button style="width:32%" type="primary" :loading="!registerok" @click="registersend()" class="h-[40px] text-[12px] $-font-[600] flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
												{{ registertime ? registertime + 's' : $t('indexTitle.title488') }}
										</el-button>
									</div>
									<div v-if="registerisShowcode && !registerisShowThreess"
										class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
										<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
												aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
												class="text-[14px] pl-[5px] !text-[gray]">{{ registercodesamll }}</span>
										</div>
									</div>
								</div>
								
								<div class="pt-[10px] flex justify-center text-[14px]">{{ $t('indexTitle.title433') }} ? <span
									class="pl-[10px] text-[#4dfeff] cursor-pointer $-font-[600]"
									@click="registerShow = false; loginShow = true">{{ $t('indexTitle.title2') }}</span>
								</div>
							</div>
							<div class="relative mt-[15px]">
								<div class="top-0 w-full flex justify-center items-center text-black">
									<el-button type="primary" :loading="isloadingTowShow" @click="registers()"
										class="h-[40px] text-[16px] $-font-[600] w-full flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
										{{ $t('indexTitle.title1') }}
									</el-button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</el-dialog>
		</div>

		<div class="flex justify-center items-center vfm vfm--fixed vfm--inset" role="dialog" aria-modal="true"
			style="z-index: 1000;" v-if="registerShow && !$appData.isMobile">
			<div class="vfm__overlay vfm--overlay vfm--absolute vfm--inset vfm--prevent-none" aria-hidden="true"></div>
			<div class="vfm__content vfm--outline-none w-[calc(100%-20px)] lg:w-[1050px] bg-[#1c1c1c] relative flex items-center justify-center rounded-lg"
				tabindex="0">
				<div
					class="flex w-full min-h-[547px] lg:min-h-[600px] max-h-[650px] overflow-y-auto h-full relative rounded-xl">
					<div class="absolute right-4 top-6 cursor-pointer" @click="registerShow = false"><i
							class="mdi-close-circle-outline mdi v-icon notranslate v-theme--light text-white"
							aria-hidden="true" style="font-size: 28px; height: 28px; width: 28px;"></i></div><img
						data-nuxt-img="" class="rounded-l-[6px] lg:block hidden w-[430px]"
						src="@/assets/newimg/login_banner_v.webp">
					<div class="text-white flex flex-col items-center w-full lg:w-[calc(100%-430px)]"><img data-nuxt-img=""
							class="w-[150px] mt-[15px]" src="@/assets/newimg/wgclub_logo.webp">
						<div class="$-font-[600] text-[20px]">{{ $t('indexTitle.title1') }}</div>
						<div class="flex w-full flex-col items-center lg:px-[105px] pt-[20px]">
							<form class="flex flex-col w-full px-[10px] lg:px-[40px]" data-gtm-form-interact-id="2">
								<div>
									<div class="flex flex-col relative">
										<div><input type="text"
												class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
												v-model="registername" maxlength="12" minlength="6"
												:placeholder="$t('indexTitle.title481')"
												data-gtm-form-interact-field-id="4">
											<div class="absolute left-[2px] bottom-[10px]"></div>
											<!-- 错误提示 -->
											<div v-if="registerisShowOness && !registerisShowThreess"
												class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
												<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
														aria-hidden="true"
														style="font-size: 15px; height: 15px; width: 15px;"></i><span
														class="text-[14px] pl-[5px] !text-[gray]">{{ registernamesmall }}</span>
												</div>
											</div>
											<div v-if="!registerisShowOness && registerisShowThreess"
												class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
												<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
														aria-hidden="true"
														style="font-size: 15px; height: 15px; width: 15px;"></i><span
														class="text-[14px] pl-[5px] !text-[gray]">{{ registermessageText }}</span>
												</div>
												<!-- 错误提示 -->
											</div>
										</div>
									</div>

									<div class="pt-[30px] flex flex-col relative">
										<div><input autocomplete="new-password" name="new-password"
												class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
												:type="registerPasswordType" v-model="registerpassword" maxlength="16"
												:placeholder="$t('indexTitle.title482')"
												data-gtm-form-interact-field-id="5">
											<div class="absolute left-[2px] bottom-[10px]"></div>
											<!-- 错误提示 -->
											<div v-if="registerisShowTowss && !registerisShowThreess"
												class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
												<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
														aria-hidden="true"
														style="font-size: 15px; height: 15px; width: 15px;"></i><span
														class="text-[14px] pl-[5px] !text-[gray]">{{ registerpsdsamll }}</span>
												</div>
											</div>
											<!-- <div v-if="!registerisShowTowss&&registerisShowThreess"
													class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
													<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
															aria-hidden="true"
															style="font-size: 15px; height: 15px; width: 15px;"></i><span
															class="text-[14px] pl-[5px] !text-[gray]">{{registermessageText}}</span>
													</div> -->
										</div>
										<!-- 错误提示 -->
										<div class="absolute right-[10px] top-[40px] cursor-pointer">
											<img class="size-[20px]" src="@/assets/newimg/eye_invisible.svg"
												@click="registerPasswordType = 'text'"
												v-if="registerPasswordType == 'password'">
											<img class="size-[20px]" src="@/assets/newimg/eye_visible.svg"
												@click="registerPasswordType = 'password'"
												v-if="registerPasswordType == 'text'">
										</div>

									</div>
								
									<div class="pt-[30px] flex flex-col relative">
										<div><input type="text"
												class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
												v-model="registerrealname" maxlength="32"
												:placeholder="$t('indexTitle.title483')" data-gtm-form-interact-field-id="4">
											<div class="absolute left-[2px] bottom-[10px]"></div>
											<!-- 错误提示 -->
											<div v-if="registerisShowfivess && !registerisShowThreess"
												class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
												<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
														aria-hidden="true"
														style="font-size: 15px; height: 15px; width: 15px;"></i><span
														class="text-[14px] pl-[5px] !text-[gray]">{{ registerrealnamesmall }}</span>
												</div>
											</div>
											<!-- <div v-if="!registerisShowfivess&&registerisShowThreess"
														class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
														<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
																aria-hidden="true"
																style="font-size: 15px; height: 15px; width: 15px;"></i><span
																class="text-[14px] pl-[5px] !text-[gray]">{{registermessageText}}</span>
														</div> -->
										</div>
									</div>
						

									<div class="pt-[30px] flex flex-col relative">
										<div>
											<div class="flex">
												<div 
													class="bg-[#353535] select-root flex items-center relative justify-between min-w-[110px] max-w-[110px] rounded-[4px] h-[40px] !text-theme-text-muted !bg-theme-bg-secondary mr-[5px] !min-w-[110px]">
													<div  class="w-full text-[14px] cursor-pointer h-full flex items-center pr-1 overflow-hidden">
														<div 
															class="!text-[16px] pl-[15px] overflow-hidden text-ellipsis whitespace-nowrap common_select-title">+852 香港
														</div>
													</div>
												</div>
												<input
														class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
														v-model="registerphone" type="tel" maxlength="20"
														:placeholder="$t('indexTitle.title484')">
											</div>
											<div class="absolute left-[2px] bottom-[10px]"></div>
											<!-- 错误提示 -->
											<div v-if="registerisShowFourss && !registerisShowThreess"
												class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
												<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
														aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
														class="text-[14px] pl-[5px] !text-[gray]">{{ registerphonesamll }}</span>
												</div>
											</div>

										</div>
									</div>
									<div class="pt-[30px] flex flex-col relative">
										<div class="flex justify-between">
											<div class="w-[65%]"><input
													class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
													v-model="registercode" maxlength="6" :placeholder="$t('indexTitle.title487')" inputmode="numeric"  pattern="[0-9]*" autocomplete="one-time-code">
											</div>
											<el-button style="width:32%" type="primary" :loading="!registerok" @click="registersend()" class="h-[40px] text-[12px] $-font-[600] flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
													{{ registertime ? registertime + 's' : $t('indexTitle.title488') }}
											</el-button>
										</div>
										<div v-if="registerisShowcode && !registerisShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ registercodesamll }}</span>
											</div>
										</div>
									</div>
									
									<div class="pt-[10px] flex justify-center text-[14px]">{{ $t('indexTitle.title433') }} ? <span
										class="pl-[10px] text-[#4dfeff] cursor-pointer $-font-[600]"
										@click="registerShow = false; loginShow = true">{{ $t('indexTitle.title2') }}</span></div>
								</div>
								<div class="relative mt-[15px]">
									<div class="top-0 w-full flex justify-center items-center text-black">
										<el-button type="primary" :loading="isloadingTowShow" @click="registers()"
											class="h-[40px] text-[16px] $-font-[600] w-full flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
											{{ $t('indexTitle.title1') }}
										</el-button>
									</div>
								</div>
							</form>
						</div>
					</div>	
				
				</div>

		
			</div>
		</div>
		<!-- 注册结束 -->
		
		<!--忘记密码-->
		<div v-if="$appData.isMobile">
			<el-dialog :visible.sync="forgotShow" center width="380px">
				<div class="text-white flex flex-col items-center w-full" style="margin-top: -60px;">
					<img data-nuxt-img="" class="w-[150px] mt-[20px]" src="@/assets/newimg/wgclub_logo.webp">
					<div class="text-[18px] font-bold text-white mt-[10px]">{{ $t('indexTitle.title491') }}</div>
					<form class="flex flex-col w-full px-[20px] lg:px-[10px]" style="margin-top: 20px;">
						<div class="flex flex-col pb-[10px] relative">
							<div class="">
								<div class="flex">
												<div 
													class="bg-[#353535] select-root flex items-center relative justify-between min-w-[110px] max-w-[110px] rounded-[4px] h-[40px] !text-theme-text-muted !bg-theme-bg-secondary mr-[5px] !min-w-[110px]">
													<div  class="w-full text-[14px] cursor-pointer h-full flex items-center pr-1 overflow-hidden">
														<div 
															class="!text-[16px] pl-[15px] overflow-hidden text-ellipsis whitespace-nowrap common_select-title">+852 香港
														</div>
													</div>
												</div>
												<input type="tel"
									class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
									:placeholder="$t('indexTitle.title484')" v-model="forgotphone" maxlength="20">
								</div>
							</div>
							<div v-if="forgotisShowPhoness && !forgotisShowThreess"
								class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
								<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
										aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
										class="text-[14px] pl-[5px] !text-[gray]">{{ forgotphonesamll }}</span></div>
							</div>
						</div>
						<div class="pb-[10px] flex flex-col relative">
							<div class="flex justify-between">
								<div class="w-[65%]"><input
										class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
										v-model="forgotcode" maxlength="6" :placeholder="$t('indexTitle.title487')">
								</div>
								<el-button style="width:32%" type="primary" :loading="!forgotok" @click="forgotsend()" class="h-[40px] text-[12px] $-font-[600] flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
									{{ forgottime ? forgottime + 's' : $t('indexTitle.title488') }}
								</el-button>
							</div>
							<div v-if="forgotisShowCodess && !forgotisShowThreess"
								class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
								<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
										aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
										class="text-[14px] pl-[5px] !text-[gray]">{{ forgotcodesamll }}</span></div>
							</div>
						</div>
						<div class="flex flex-col pb-[10px] relative">
							<div class=""><input
									class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
									:placeholder="$t('indexTitle.title492')" :type="forgotpasswordType"
									v-model="forgotpassword">
								<div class="absolute left-[2px] top-[10%]"></div>
								<div v-if="forgotisShowPwdss && !forgotisShowThreess"
									class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
									<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
											aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
											class="text-[14px] pl-[5px] !text-[gray]">{{ forgotpwdsamll }}</span></div>
								</div>
								<div class="absolute right-[10px] top-[7px] cursor-pointer">
									<img class="size-[20px]" src="@/assets/newimg/eye_invisible.svg"
										@click="forgotpasswordType = 'text'" v-if="forgotpasswordType == 'password'">
									<img class="size-[20px]" src="@/assets/newimg/eye_visible.svg"
										@click="forgotpasswordType = 'password'" v-if="forgotpasswordType == 'text'">
								</div>
							</div>
						</div>
						<div v-if="forgotisShowThreess"
							class="peer-focus:visible bg-[#1a1c20] !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
							<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
									aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
									class="text-[14px] pl-[5px] !text-[gray]">{{ forgotmessageText }}</span></div>
						</div>
						<div class="relative mt-[15px]">
							<div class="top-0 w-full flex justify-center items-center text-black">
								<el-button type="primary" :loading="isloadingTowShow" @click="forgotsubmit()"
									class="h-[40px] text-[16px] $-font-[600] w-full flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
									{{ $t('indexTitle.title493') }}
								</el-button>
							</div>
						</div>
					</form>
					<div class="lg:w-[500px]">
						<div class="pt-[20px] z-[1] text-[14px] text-[#aba9a9] font-medium flex justify-between items-center">
							<div class="flex justify-center w-full px-[10px]">
								<span class="cursor-pointer text-[#41ebe2] $-font-[600]"
									@click="forgotShow = false; loginShow = true">
									{{ $t('indexTitle.title2') }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</el-dialog> 
		</div>
		<div class="flex justify-center items-center vfm vfm--fixed vfm--inset" role="dialog" aria-modal="true"
			style="z-index: 1000;" v-if="forgotShow && !$appData.isMobile">
			<div class="vfm__overlay vfm--overlay vfm--absolute vfm--inset vfm--prevent-none" aria-hidden="true"></div>
			<div class="vfm__content vfm--outline-none w-[calc(100%-20px)] lg:w-[1050px] pb-[20px] bg-[#1c1c1c] relative flex items-center justify-center rounded-lg"
				tabindex="0">
				<div class="flex w-full min-h-[547px] lg:min-h-[600px] max-h-[650px] overflow-y-auto h-full relative rounded-xl"
					style="min-height: 374px;">
					<div class="absolute right-4 top-6 cursor-pointer" @click="forgotShow = false"><i
							class="mdi-close-circle-outline mdi v-icon notranslate v-theme--light text-white"
							aria-hidden="true" style="font-size: 28px; height: 28px; width: 28px;"></i></div><img
						data-nuxt-img="" class="rounded-l-[6px] lg:block hidden w-[430px]"
						src="@/assets/newimg/login_banner_v.webp">
					<div class="text-white flex flex-col items-center w-full lg:w-[calc(100%-430px)]"><img data-nuxt-img=""
							class="w-[150px] mt-[20px]" src="@/assets/newimg/wgclub_logo.webp">
						<div class="$-font-[600] pt-[10px] lg:pt-[15px] text-[20px]">{{ $t('indexTitle.title491') }}</div>
						<div class="flex w-full flex-col items-center lg:px-[135px] pt-[20px] lg:pt-[40px]">
							<form class="flex flex-col w-full px-[20px] lg:px-[10px]">
								<div class="flex flex-col pb-[10px] relative">
									<div class="">
										<div class="flex">
												<div 
													class="bg-[#353535] select-root flex items-center relative justify-between min-w-[110px] max-w-[110px] rounded-[4px] h-[40px] !text-theme-text-muted !bg-theme-bg-secondary mr-[5px] !min-w-[110px]">
													<div  class="w-full text-[14px] cursor-pointer h-full flex items-center pr-1 overflow-hidden">
														<div 
															class="!text-[16px] pl-[15px] overflow-hidden text-ellipsis whitespace-nowrap common_select-title">+852 香港
														</div>
													</div>
												</div>
												<input type="tel"
											class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
											:placeholder="$t('indexTitle.title484')" v-model="forgotphone" maxlength="20">
										</div>
									</div>
									<div v-if="forgotisShowPhoness && !forgotisShowThreess"
										class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
										<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
												aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
												class="text-[14px] pl-[5px] !text-[gray]">{{ forgotphonesamll }}</span></div>
									</div>
								</div>
								<div class="pb-[10px] flex flex-col relative">
									<div class="flex justify-between">
										<div class="w-[65%]"><input
												class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
												v-model="forgotcode" maxlength="6" :placeholder="$t('indexTitle.title487')">
										</div>
										<el-button style="width:32%" type="primary" :loading="!forgotok" @click="forgotsend()" class="h-[40px] text-[12px] $-font-[600] flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
													{{ forgottime ? forgottime + 's' : $t('indexTitle.title488') }}
										</el-button>
										
									</div>
									<div v-if="forgotisShowCodess && !forgotisShowThreess"
										class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
										<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
												aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
												class="text-[14px] pl-[5px] !text-[gray]">{{ forgotcodesamll }}</span></div>
									</div>
								</div>
								<div class="flex flex-col pb-[10px] relative">
									<div class=""><input
											class="peer placeholder:text-[#aba9a9] bg-[#353535] px-[15px] outline-none h-[40px] w-full rounded-md"
											:placeholder="$t('indexTitle.title492')" :type="forgotpasswordType"
											v-model="forgotpassword">
										<div class="absolute left-[2px] top-[10%]"></div>
										<div v-if="forgotisShowPwdss && !forgotisShowThreess"
											class="peer-focus:visible bottom-[51px] bg-[#1a1c20] absolute !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
											<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
													aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
													class="text-[14px] pl-[5px] !text-[gray]">{{ forgotpwdsamll }}</span></div>
										</div>
										<div class="absolute right-[10px] top-[7px] cursor-pointer">
											<img class="size-[20px]" src="@/assets/newimg/eye_invisible.svg"
												@click="forgotpasswordType = 'text'" v-if="forgotpasswordType == 'password'">
											<img class="size-[20px]" src="@/assets/newimg/eye_visible.svg"
												@click="forgotpasswordType = 'password'" v-if="forgotpasswordType == 'text'">
										</div>
									</div>
								</div>
								<div v-if="forgotisShowThreess"
									class="peer-focus:visible bg-[#1a1c20] !border-[#353535] !border -nowrap w-full py-[8px] px-[9px] z-10 rounded">
									<div><i class="mdi-close-thick mdi v-icon notranslate v-theme--light text-red pb-[3px]"
											aria-hidden="true" style="font-size: 15px; height: 15px; width: 15px;"></i><span
											class="text-[14px] pl-[5px] !text-[gray]">{{ forgotmessageText }}</span></div>
								</div>
								<div class="relative mt-[15px]">
									<div class="top-0 w-full flex justify-center items-center text-black"><button @click="forgotsubmit()"
											type="button"
											class="h-[40px] text-[16px] $-font-[600] w-full flex items-center justify-center rounded-[8px] bg-[#4dffff] disabled:opacity-70 disabled:cursor-not-allowed">
											{{ $t('indexTitle.title493') }}</button></div>
								</div>
							</form>
						</div>
						<div class="lg:w-[500px]">
							<div class="pt-[20px] z-[1] text-[14px] text-[#aba9a9] font-medium flex justify-between items-center">
								<div class="flex justify-center w-full px-[10px]">
									<span class="cursor-pointer text-[#41ebe2] $-font-[600]"
										@click="forgotShow = false; loginShow = true">
										{{ $t('indexTitle.title2') }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--忘记密码结束-->

		<!--平台公告-->
		<div class="flex justify-center items-center vfm vfm--fixed vfm--inset" role="dialog" aria-modal="true"
			style="z-index: 1000;" v-if="msgshow">
			<div class="vfm__overlay vfm--overlay vfm--absolute vfm--inset vfm--prevent-none" aria-hidden="true"></div>
			<div class="vfm__content vfm--outline-none relative flex items-center justify-center rounded-lg" tabindex="0">
				<div
					class="bg-[#1c1c1c] text-white overflow-y-auto w-[350px] h-[540px] lg:w-[480px] lg:h-[530px] rounded-lg overflow-hidden">
					<div class="flex justify-between items-center px-4 pb-4 pt-3  border-[#878787]">
						<div
							class="pt-[0px] text-center w-full text-[16px] $-font-[600] !border-b !border-[#cacaca] mx-[5px] lg:mx-[40px] pb-[10px]">
							{{ $t('indexTitle.title33') }}
						</div><button class="absolute right-4 top-[10px] text-xl" @click="msgshow = false"><i
								class="mdi-close-circle-outline mdi v-icon notranslate v-theme--light" aria-hidden="true"
								style="font-size: 28px; height: 28px; width: 28px;"></i></button>
					</div>
					<div class="px-[20px] lg:px-[80px] border-gray-600 grid grid-cols-2 gap-x-[20px]"><button
							class="px-6 py-2 rounded text-[14px] $-font-[600]" :class="msgtab == 0 ? 'bg-white' : 'bg-[#333]'"
							@click="personalMsg()">{{ $t('indexTitle.title48') }}</button><button
							class="px-6 py-2 rounded text-[14px] $-font-[600]" :class="msgtab == 1 ? 'bg-white' : 'bg-[#333]'"
							@click="personalMsg(1)">{{ $t('indexTitle.title157') }}</button></div>
					<div>
						<!-- <div
								class="flex px-[20px] lg:px-[60px] pt-[10px] justify-start gap-6 text-white mb-3 text-[14px]">
								<button class="cursor-pointer $-font-[600]">全部已读</button></div> -->
						<div class="overflow-y-auto h-[calc(100vh-310px)] lg:h-[calc(100vh-430px)] scrollableHidden"
							v-if="noticeList.length > 0">
							<div class="pt-[10px] px-[20px] lg:px-[60px]" v-for="(it, index) in noticeList" :key="index"
								@click="goNextPage(it)">
								<div class="space-y-4">
									<div class="relative bg-[#444] text-white rounded-lg py-2 px-4 pl-6">
										<div class="bg-[#585858] absolute left-0 top-0 bottom-0 w-1 rounded-l-lg"></div>
										<div class="text-xs text-gray-300 mb-1 $-font-[600]">{{ it.created_at }}</div>
										<div class="$-font-[600] mb-1">【{{ it.title }}】</div>
										<div class="text-gray-200 text-[12px] lg:text-[16px] "
											:class="it.open ? 'line-clamp-[100]' : 'line-clamp-[2]'">
											{{ it.content }}
										</div>
										<div class="flex justify-end items-center mt-1">
											<button v-if="it.open" @click="it.open = false"
												class="flex items-center text-gray-300 text-[12px] lg:text-[16px]">{{ $t('indexTitle.title381') }}
												<i class="mdi-chevron-down mdi v-icon notranslate v-theme--light v-icon--size-default"
													aria-hidden="true"></i></button>
											<button v-if="!it.open" @click="it.open = true"
												class="flex items-center text-gray-300 text-[12px] lg:text-[16px]">{{ $t('indexTitle.title380') }}
												<i class="mdi-chevron-down mdi v-icon notranslate v-theme--light v-icon--size-default"
													aria-hidden="true"></i></button>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
		<!--平台公告-->

		<!--体育-->
		<el-dialog title="" :visible.sync="isLoadingShow" width="100%" :show-close='false' center>
			<loading :gameShowTow='gameShow' :logo="systemconfig.m_site_logo || ''"></loading>
		</el-dialog>
		<!--体育-->
		<div class="wrapper" v-if="url">
			<div class="drag-container" ref="container">
				<img src="@/assets/images/home.svg" alt="" :style="{
					position: 'absolute',
					left: img.x + 'px',
					top: img.y + 'px',
					cursor: 'move',
					userSelect: 'none',
					width: '40px',
					height: '40px',
					pointerEvents: 'auto',
					/* 禁用浏览器默认拖拽 */
					WebkitUserDrag: 'none',
					userDrag: 'none',
					zIndex: 999,
				}" @touchstart="startDrag" @mousedown="startDrag($event)" @click="url = ''" />
			</div>
			<iframe :src="url"></iframe>
		</div>
		<!-- 客服iframe -->
		<div class="wrapper" v-if="url">
			<div class="drag-container" ref="container">
				<img src="../assets/images/home.svg" alt="" :style="{
					position: 'absolute',
					left: img.x + 'px',
					top: img.y + 'px',
					cursor: 'move',
					userSelect: 'none',
					width: '40px',
					height: '40px',
					pointerEvents: 'auto',
					/* 禁用浏览器默认拖拽 */
					WebkitUserDrag: 'none',
					userDrag: 'none',
					zIndex: 999,
				}" @touchstart="startDrag" @mousedown="startDrag($event)" @click="url = ''" />
			</div>
			<iframe :src="url"></iframe>
		</div>
		<!-- 客服iframe结束 -->
		<!--验证码-->
			<el-dialog v-if="hcaptchaSitekey" :visible.sync="hcaptchaDialogVisible" center width="350px" style="padding-top:20vh;" :show-close='false' >
				<vue-hcaptcha ref="hcaptchaDesktop" :sitekey="hcaptchaSitekey" @verify="hcaptchaverify($event)" @error="hcaptchaerror()" style="margin-top: -25px;">
				</vue-hcaptcha>
			</el-dialog>
	
		<!--验证码结束-->

		<!-- 切换语言弹窗 -->
		<div v-if="langshow" class="mp-lang-mask" @click.self="langshow = false">
			<div class="mp-lang-modal" role="dialog" :aria-label="$t('indexTitle.title626')">
				<div class="mp-lang-modal__head">
					<span>{{ $t('indexTitle.title626') }}</span>
					<button type="button" class="mp-lang-modal__close" @click="langshow = false" aria-label="close">×</button>
				</div>
				<div class="mp-lang-modal__body">
					<button
						type="button"
						class="mp-lang-tile"
						:class="{ 'is-active': $i18n.locale === 'en' }"
						@click="switchLang('en')"
					>
						<span class="mp-lang-tile__check" v-if="$i18n.locale === 'en'">✓</span>
						<img src="@/assets/newimg/US.png" alt="" />
						<span>English</span>
					</button>
					<button
						type="button"
						class="mp-lang-tile"
						:class="{ 'is-active': $i18n.locale === 'th' }"
						@click="switchLang('th')"
					>
						<span class="mp-lang-tile__check" v-if="$i18n.locale === 'th'">✓</span>
						<img src="@/assets/newimg/TH.png" alt="" />
						<span>ภาษาไทย</span>
					</button>
					<button
						type="button"
						class="mp-lang-tile"
						:class="{ 'is-active': $i18n.locale === 'zh' }"
						@click="switchLang('zh')"
					>
						<span class="mp-lang-tile__check" v-if="$i18n.locale === 'zh'">✓</span>
						<img src="@/assets/newimg/CN.png" alt="" />
						<span>简体中文</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	userinfo,
	getsystemconfig,
	transferAll,
	login,
	register,
	sendmsg,
	resetloginpassword,
	resetloginpasswordNologin,
	noticeList,
	playGame,
} from "../utils/api.js";
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";
import loading from "@/components/loading.vue";
import { eventBus } from "@/App.vue";
import { resolveMediaUrl } from "@/utils/mediaUrl.js";
export default {
	components: {
		loading,
		VueHcaptcha,
	},
	data() {
		return {
			gameShow: false,
			token: true,
			isrefresh: "",
			isShowLang: false,
			isShowyue: false,
			info: {},
			tran: true,
			isloadingTowShow: false,
			kefushow: false,
			img: {
				x: 40,
				y: 60
			},
			isDragging: false,
			offsetX: 0,
			offsetY: 0,
			dragMask: null,
			systemconfig: {},
			isLoadingShow: false,
			url: "",
			loginShow: false,
			registerShow: false,

			hcaptchaToken: '',
			hcaptchaSitekey: '',
			hcaptchaDialogVisible: false,
			hcaptchaAction: '',
			needHcaptcha: false,
			// hcaptchaSitekey: '',

			name: '',
			password: '',

			namesmall: '',
			psdsamll: '',
			isShowOness: false,
			isShowTowss: false,
			isShowThreess: false,
			messageText: "",
			activitId: true,
			passwordtype: 'password',
			registerPasswordType: 'password',
			registersixPasswordType: 'password',

			registername: '',
			registerpassword: '',
			registerrealname: '',
			registerphone: '',
			registertikuanpsg: '',
			registernamesmall: '',
			registerpsdsamll: '',
			registerrealnamesmall: '',
			registertikuanpsgsmall: '',
			registerphonesamll: '',
			registermessageText: "",
			registerisShowOness: false,
			registerisShowTowss: false,
			registerisShowFourss: false,
			registerisShowThreess: false,
			registerisShowfivess: false,
			registerisShowsixss: false,
			registerisShowcode: false,
			registercodesamll: '',
			registercode: '',
			registertimer: '',
			registertime: '',
			registercountTime: 120,
			registerok: 1,
			isMobile: true,
			msgshow: false,
			noticeList: [],
			tab: 0,
			msgtab: 0,
			langshow: false,
			mineshow: false,
			isRotating: false,
			loginTab: 0,
			loginphone: '',
			loginphonesamll: '',
			loginisShowPhoness: false,
			forgotShow: false,
			forgotphone: '',
			forgotcode: '',
			forgotpassword: '',
			forgotpasswordType: 'password',
			forgotisShowPhoness: false,
			forgotisShowCodess: false,
			forgotisShowPwdss: false,
			forgotisShowThreess: false,
			forgotphonesamll: '',
			forgotcodesamll: '',
			forgotpwdsamll: '',
			forgotmessageText: '',
			forgottimer: '',
			forgottime: '',
			forgotcountTime: 120,
			forgotok: 1,
		}
	},
	created() {
		this.$bus.$on('openLoginModal', () => {
			this.$router.push('/login')
		})
		this.$bus.$on('openRegisterModal', () => {
			this.$router.push('/register')
		})
		this.$bus.$on('refreshUserInfo', () => {
			this.getuserinfo();
		})
		this.$bus.$on('openTiyu', () => {
			this.tiyu()
		})
		this.$bus.$on('openKefu', () => {
			this.$router.push('/contact')
		})
	},
	beforeDestroy() {
		// 页面销毁时取消监听（好习惯）
		this.$bus.$off('openLoginModal')
		this.$bus.$off('openRegisterModal')
		this.$bus.$off('refreshUserInfo')
		this.$bus.$off('openTiyu')
		this.$bus.$off('openKefu')
	},
	mounted() {
		if (localStorage.getItem("token") && !localStorage.getItem("userInfo")) {
			this.getuserinfo();
		} else if (localStorage.getItem("token") && localStorage.getItem("userInfo")) {
			this.info = JSON.parse(localStorage.getItem('userInfo'))
			this.getuserinfo();
		} else {
			this.token = false;
		}
		if (localStorage.getItem('nameNum')) {
			this.name = localStorage.getItem('nameNum');
		}
		if (localStorage.getItem('passwordNum')) {
			this.password = localStorage.getItem('passwordNum');
		}
		if (localStorage.getItem('phoneNum')) {
			this.loginphone = localStorage.getItem('phoneNum');
		}


		var that = this;
		this.getSystemconfig();
		window.location.href.indexOf("?show") > -1 ? this.isLoadingShow = true : ''
		const url = new URL(window.location.href)
		const inviteCode = url.searchParams.get('invite_code')
		if (inviteCode) {
			localStorage.setItem('invite_code', inviteCode)
		}
	},
	methods: {
		toggleLeft() {
			this.mineshow = false
			eventBus.$emit('toggleLeft')
		},
		openPcSideMenu() {
			this.mineshow = false
			eventBus.$emit('toggleLeft', true)
		},
		isPcNavActive(path) {
			const p = (this.$route && this.$route.path) || '/'
			if (path === '/') return p === '/' || p === '/index' || p === '/home'
			return p === path || p.indexOf(path + '/') === 0
		},
		changelang() {
			// 只开顶栏弹窗，避免再触发 leftpc 旧弹窗叠一层遮罩
			this.langshow = true
		},
		getEventClientXY(e) {
			if (e.type.startsWith('touch')) {
				// touch 事件：e.touches[0]
				const touch = e.touches[0] || e.changedTouches[0];
				return { x: touch.clientX, y: touch.clientY };
			} else {
				// mouse 事件
				return { x: e.clientX, y: e.clientY };
			}
		},

		startDrag(e) {
			const imgRect = e.target.getBoundingClientRect();
			const { x: clientX, y: clientY } = this.getEventClientXY(e);
			this.isDragging = true;
			this.offsetX = clientX - imgRect.left;
			this.offsetY = clientY - imgRect.top;
			if (!this.dragMask) {
				this.dragMask = document.createElement('div');
				this.dragMask.style.cssText = `
			        position: fixed;
			        top: 0; left: 0;
			        width: 100vw; height: 100vh;
			        z-index: 99998;
			        pointer-events: none;
			      `;
				document.body.appendChild(this.dragMask);
			}
			document.addEventListener('mousemove', this.onDragMove);
			document.addEventListener('touchmove', this.onDragMove, { passive: false });
			document.addEventListener('mouseup', this.stopDrag);
			document.addEventListener('touchend', this.stopDrag);
		},

		onDragMove(e) {
			if (!this.isDragging) return;
			e.preventDefault(); // 阻止页面滚动
			const { x: clientX, y: clientY } = this.getEventClientXY(e);
			const containerRect = this.$refs.container.getBoundingClientRect();

			let newX = clientX - this.offsetX;
			let newY = clientY - this.offsetY;

			newX = Math.max(0, Math.min(newX, containerRect.width - 40));
			newY = Math.max(0, Math.min(newY, containerRect.height - 40));

			this.img.x = newX;
			this.img.y = newY;
		},

		stopDrag() {
			this.isDragging = false;
			document.removeEventListener('mousemove', this.onDragMove);
			document.removeEventListener('touchmove', this.onDragMove);
			document.removeEventListener('mouseup', this.stopDrag);
			document.removeEventListener('touchend', this.stopDrag);

			if (this.dragMask) {
				document.body.removeChild(this.dragMask);
				this.dragMask = null;
			}
		},
		tiyu() {
			var item = { value: 'DBSB', type: 'SB' };
			var type = 'CB';
			let that = this;
			if (!localStorage.getItem("token")) {
				// this.$router.push("/login");
				localStorage.removeItem('token');
				localStorage.removeItem('siteTitle');
				localStorage.removeItem('siteIco');
				if (localStorage.getItem('languageTow')) {
					localStorage.removeItem('languageTow');
				}
				if (localStorage.getItem('language')) {
					localStorage.removeItem('language');
				}
				if (localStorage.getItem('userInfo')) {
					localStorage.removeItem('userInfo');
				}
				if (localStorage.getItem('tongjilistTow')) {
					localStorage.removeItem('tongjilistTow');
				}
				this.$bus.$emit('openLoginModal')
				return false;
			}
			this.isLoadingShow = true;
			this.gameShow = true;

			let data = {
				api_code: item.value,
				game_type: type,
				token: localStorage.getItem("token"),
				game_id: "",
			};
			let url = "";
			var wyWindow = "";
			playGame(data).then((res) => {
				localStorage.removeItem('show')
				this.isLoadingShow = false;
				if (res.status.errorCode == 0) {
					url = res.url;
					if (item.value == 'ST' || item.value == 'CM' || item.type == 'SL' || item.type == 'FH') {
						location.href = url;

					} else {
						this.url = url;
					}
				} else {
					this.$message({
						showClose: true,
						message: res.status.msg,
						type: "error",
					});
				}

			}).catch((error) => {
				this.isLoadingShow = false;
				localStorage.removeItem('show')
				// this.isShowLoadingTeow = false;
			});
			setTimeout(() => {
				that.$bus.$emit('refreshUserInfo')
			}, 5000);

		},
		getuserinfo() {
			userinfo()
				.then((res) => {
					if (res.status.errorCode == 0) {
						this.info = res.data;
						localStorage.setItem("userInfo", JSON.stringify(this.info))
						this.token = true;
						this.isShowyue = false;
						this.isloadingTowShow = false;
						document.body.classList.add('is-logged-in')
						this.$bus.$emit('syncGamePlayHistory')
						this.$bus.$emit('loginStateChanged')
					} else if (res.status.errorCode == 401) {
						this.token = false;
						this.info = {}
						localStorage.removeItem("token");
						localStorage.removeItem('siteTitle');
						localStorage.removeItem('siteIco');
						if (localStorage.getItem('languageTow')) {
							localStorage.removeItem('languageTow');
						}
						if (localStorage.getItem("language")) {
							localStorage.removeItem("language");
						}
						if (localStorage.getItem("userInfo")) {
							localStorage.removeItem("userInfo");
						}
						console.log('登出')
					} else {
						this.token = false;
						this.info = {}
						// this.$message.error(res.status.msg);
						this.msgTextTow = res.status.msg;
						this.isShowLoadingTeow = true;
						setTimeout(() => {
							this.isShowLoadingTeow = false;
						}, 2000)
						// this.$message({
						// 	showClose: true,
						// 	message: res.status.msg,
						// 	type: "error",
						// });
					}
				})
				.catch((err) => {
					console.log(err, "err");
				});
		},
		getrefresh() {
			this.isRotating = true;

			this.isrefresh = true;
			this.getuserinfo();
			setTimeout(() => {
				this.isRotating = false;
			}, 500); // 跟CSS动画时间一致
		},
		getShowLang() {
			this.isShowLang = !this.isShowLang;
		},
		getShowYue() {
			this.isShowyue = !this.isShowyue;
		},
		jixuAPI() {
			var that = this;
			if (!that.tran) {
				return;
			}
			that.tran = false;
			this.isloadingTowShow = true;
			transferAll({})
				.then((res) => {
					that.tran = true;
					if (res.status.errorCode == 0) {
						this.getuserinfo();
					} else {
						this.msgTextTow = res.status.msg;
						this.isShowLoadingTeow = true;
						setTimeout(() => {
							this.isShowLoadingTeow = false;
						}, 2000)
						// this.$message({
						// 	showClose: true,
						// 	message: res.status.msg,
						// 	type: "error",
						// });
					}
				})
				.catch((err) => {
					console.log(err, "err");
				});
		},

		goNextPage(page) {
			this.mineshow = false;
			if (
				(!localStorage.getItem("token") && page == "/deposit") ||
				(!localStorage.getItem("token") && page == "/withdraw")
			) {
				this.loginShow = true;
				// this.$router.push("/login");
				return false;
			}
			this.$router.push(page);
		},
		getKefu() {
			this.$router.push('/contact');
		},
		getSystemconfig() {
			this.systemconfig = {};
			getsystemconfig()
				.then((res) => {

					if (res.status.errorCode == 0) {
						this.systemconfig = res.data;
						// wyWindow.location = this.systemconfig.service_link;
						// setTimeout(() => {
						// 	this.isLoadingShow = false;
						// }, 2000);
					} else {
						// this.$message.error(res.status.msg);
						this.$message({
							showClose: true,
							message: res.status.msg,
							type: "error",
						});
					}
				})
				.catch((err) => {
					console.log(err, "err");
				});
		},
		kefu(type = 1) {
			if (type == 1) {
				this.url = this.systemconfig.service_link;
			} else {
				var wyWindow = "";
				wyWindow = window.open(location.href + '?show=1', "_blank");
				wyWindow.location = this.systemconfig.service_link2;
			}
		},
		closeGuanbi() {
			this.kefushow = false;
		},

		//登陆相关
		usernameInput() {
			// 初始化所有提示状态，避免残留
			this.isShowOness = false;
			this.isShowThreess = false;
			this.messageText = '';
			this.namesmall = '';

			// 第一步：校验是否为空
			if (!this.name) {
				this.isShowOness = true;
				this.namesmall = this.$t('indexTitle.title199'); // 原空值提示
			} else {
				const name = this.name.trim(); // 去除首尾空格（可选，根据业务需求）
				const isLengthValid = name.length >= 6 && name.length <= 12;
				const isFormatValid = /^[a-z][a-z0-9]*$/.test(name);

				// 根据不同条件展示专属提示
				if (!isFormatValid) {
					this.isShowOness = true;
					this.namesmall = '名稱需以小写字母開頭，且僅包含字母和數字';

				} else if (!isLengthValid) {
					this.isShowOness = true;
					// 格式不符合的提示（建议配置多语言，这里先写示例）
					this.namesmall = this.$t('indexTitle.title199')
				} else {
					// 所有条件都满足
					this.isShowOness = false;
					this.isShowThreess = false;
					this.messageText = '';
				}
			}
		},
		passwordInput() {
			if (!this.password) {
				this.isShowTowss = true;
				this.psdsamll = this.$t('indexTitle.title198')
			} else {
				this.isShowTowss = false;
				this.isShowThreess = false;
				this.messageText = '';
			}
			console.log(this.isShowTowss, this.isShowThreess);
		},
		loginphoneInput() {
			if (!this.loginphone) {
				this.loginisShowPhoness = true;
				this.loginphonesamll = this.$t('indexTitle.title206');
			} else {
				this.loginisShowPhoness = false;
				this.isShowThreess = false;
				this.messageText = '';
			}
		}, forgotphoneInput() {
			if (!this.forgotphone) {
				this.forgotisShowPhoness = true;
				this.forgotphonesamll = this.$t('indexTitle.title206');
			} else {
				this.forgotisShowPhoness = false;
				this.forgotisShowThreess = false;
				this.forgotmessageText = '';
			}
		},
		forgotsend() {
			if (this.forgotok != 1 || this.forgottime) {
				return false;
			}
			if (this.forgotphone == '') {
				this.forgotisShowPhoness = true;
				this.forgotphonesamll = this.$t('indexTitle.title206');
				return false
			}
			if (this.needHcaptcha) {
				this.hcaptchaShow('forgot');
			} else {
				this.forgotsendExec();
			}
		},
		forgotsendExec() {
			if (this.needHcaptcha && !this.hcaptchaToken) {
				this.$message({
					showClose: true,
					message: '請完成驗證碼驗證',
					type: "error",
				});
				return false
			}
			let data = {
				phone: this.forgotphone,
				type:2,
				hcaptchaToken: this.hcaptchaToken,
			}
			this.forgotok = 0;
			sendmsg(data).then((res) => {
				this.forgotok = 1;
				this.hcaptchaToken = '';
				if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
				if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
				if (res.status.errorCode == 0) {
					this.forgotisShowPhoness = false;
					this.needHcaptcha = false;
					this.forgotcountLastTime();
				} else if (res.data === 1) {
					this.needHcaptcha = true;
					this.hcaptchaShow('forgot');
				} else {
					this.forgotisShowPhoness = true;
					this.forgotphonesamll = res.status.msg;
					return false
				}
			}).catch((err) => {
				this.forgotok = 1;
				this.hcaptchaToken = '';
				if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
				if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
				clearInterval(this.forgottimer);
			});
		},
		forgotcountLastTime() {
			if (!this.forgottime) {
				this.forgottime = this.forgotcountTime;
				this.forgottime--;
			}
			this.forgottimer = setInterval(() => {
				if (!this.forgottime) {
					this.forgottime = this.forgotcountTime;
					return;
				}
				this.forgottime--;
				if (this.forgottime <= 0) {
					clearInterval(this.forgottimer);
					this.forgottime = 0;
				}
			}, 1000);
		},
		forgotcodeInput() {
			if (!this.forgotcode) {
				this.forgotisShowCodess = true;
				this.forgotcodesamll = this.$t('indexTitle.title487Err');
			} else {
				this.forgotisShowCodess = false;
				this.forgotisShowThreess = false;
				this.forgotmessageText = '';
			}
		},
		forgotpasswordInput() {
			if (!this.forgotpassword) {
				this.forgotisShowPwdss = true;
				this.forgotpwdsamll = this.$t('indexTitle.title198');
			} else {
				this.forgotisShowPwdss = false;
				this.forgotisShowThreess = false;
				this.forgotmessageText = '';
			}
		},
		forgotsubmit() {
			let that = this;
			this.isloadingTowShow = true;
			this.forgotisShowPhoness = false;
			this.forgotisShowCodess = false;
			this.forgotisShowPwdss = false;
			this.forgotisShowThreess = false;
			if (this.forgotphone == '') {
				this.forgotisShowPhoness = true;
				this.forgotphonesamll = this.$t('indexTitle.title206');
				this.isloadingTowShow = false;
				return false
			}
			if (this.forgotcode == '') {
				this.forgotisShowPhoness = true;
				this.forgotphonesamll = this.$t('indexTitle.title487Err');
				this.isloadingTowShow = false;
				return false
			}
			if (this.forgotpassword == '') {
				this.forgotisShowPhoness = true;
				this.forgotphonesamll = this.$t('indexTitle.title198');
				this.isloadingTowShow = false;
				return false
			}
			let data = {
				phone: this.forgotphone,
				code: this.forgotcode,
				password: this.forgotpassword
			}
			resetloginpasswordNologin(data).then((res) => {
				this.isloadingTowShow = false;
				if (res.status.errorCode == 0) {
					this.$message({
						type: 'success',
						message: res.status.msg,
						showClose: true,
						duration: 1500,
					})
					// this.forgotShow = false;
					this.forgotphone = '';
					this.forgotcode = '';
					this.forgotpassword = '';
					clearInterval(this.forgottimer);
					this.forgottime = 0;
				} else {
					this.forgotisShowPhoness = true;
					this.forgotphonesamll = res.status.msg;
				}
			}).catch((err) => {
				this.isloadingTowShow = false;
				this.hcaptchaToken = '';
				if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
				if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
				console.log(err, 'err')
			});
		},
		handleLoginClick(){
			this.isShowThreess = false;
			this.isShowOness = false;
			this.isShowTowss = false;
			if (this.loginTab == 0 && this.name == '') {
				this.isShowOness = true;
				this.namesmall = this.$t('indexTitle.title197');
				return false;
			}
			if (this.loginTab == 1 && this.loginphone == '') {
				this.loginisShowPhoness = true;
				this.loginphonesamll = this.$t('indexTitle.title206');
				return false;
			}
			if (this.password == '') {
				this.isShowTowss = true;
				this.psdsamll = this.$t('indexTitle.title198');
				return false;
			}
			// if (this.needHcaptcha) {
			// 	this.hcaptchaShow('login');
			// } else {
				this.logins();
			// }
		},
		hcaptchaShow(action = 'login'){
			this.hcaptchaSitekey = this.systemconfig.hcaptchaSitekey || '';
			this.hcaptchaToken = '';
			this.hcaptchaAction = action;
			this.hcaptchaDialogVisible = true;
		},
		hcaptchaerror(){
			this.hcaptchaToken = ''; 
			this.hcaptchaDialogVisible = false;
			this.$message({
				showClose: true,
				message: '機器人驗證失敗',
				type: "error",
			});
		},
		hcaptchaverify(res){
			this.hcaptchaToken = res;
			this.hcaptchaDialogVisible = false;
			if (this.hcaptchaAction === 'forgot') {
				this.forgotsendExec();
			} else if (this.hcaptchaAction === 'register') {
				this.registersendExec();
			} else {
				this.logins();
			}
		},
		
		logins() {
			let that = this;
			this.isloadingTowShow = true;
			this.isShowThreess = false;
			this.isShowOness = false;
			this.isShowTowss = false;
			if (this.loginTab == 0 && this.name == '') {
				this.isShowOness = true;
				this.namesmall = this.$t('indexTitle.title197')
				this.isloadingTowShow = false;
				return false
			}
			if (this.loginTab == 1 && this.loginphone == '') {
				this.loginisShowPhoness = true;
				this.loginphonesamll = this.$t('indexTitle.title206');
				this.isloadingTowShow = false;
				return false
			}
			if (this.password == '') {

				this.isShowOness = true;
				this.namesmall = this.$t('indexTitle.title198')

				this.loginisShowPhoness = true;
				this.loginphonesamll = this.$t('indexTitle.title198');

				// this.isShowTowss = true;
				// this.psdsamll = this.$t('indexTitle.title198')
				this.isloadingTowShow = false;
				return false
			}
			// if (this.needHcaptcha && !this.hcaptchaToken) {
			// 	this.$message({
			// 		showClose: true,
			// 		message: '請完成驗證碼驗證',
			// 		type: "error",
			// 	});

			// 	this.isloadingTowShow = false;
			// 	return false
			// }
			let data = {
				name: this.loginTab == 0 ? this.name : '',
				phone: this.loginTab == 1 ? this.loginphone : '',
				password: this.password,
				hcaptchaToken: this.hcaptchaToken,
			}
			login(data).then((res) => {
				if (res.status.errorCode == 0) {
					this.$message({
						type: 'success',
						message: res.status.msg,
						showClose: true,
						duration: 1500,
					})
					this.token = res.data
					localStorage.removeItem('userInfo')
					localStorage.setItem('token', res.data)
					this.$bus.$emit('syncGamePlayHistory')
					if (this.activitId) {
						localStorage.setItem('nameNum',  this.name)
						localStorage.setItem('phoneNum',  this.loginphone)
						localStorage.setItem('passwordNum', this.password)
					} else {
						localStorage.setItem('nameNum', '')
						localStorage.setItem('phoneNum',  '')
						localStorage.setItem('passwordNum', '')
					}
					this.getuserinfo()
					this.name = '';
					this.password = '';
					this.loginphone = '';
					this.loginShow = false;
					this.hcaptchaToken = '';
					this.needHcaptcha = false;
					if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
					if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
				} else {
					this.isloadingTowShow = false;
					this.hcaptchaToken = '';
					if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
					if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
					if (res.data === 1) {
						this.needHcaptcha = true;
						this.hcaptchaShow('login');
					} else if(this.loginTab==0){
						this.isShowThreess = true;
						this.messageText = res.status.msg;
					} else if(this.loginTab==1){
						this.loginisShowPhoness = true;
						this.loginphonesamll = res.status.msg;
					}

				}
			}).catch((err) => {
				this.isloadingTowShow = false;
				this.hcaptchaToken = '';
				if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
				if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
				console.log(err, 'err')
			});
		},
		//登陆相关结束

		//注册相关
		registerusernameInput() {
			// 初始化所有提示状态，避免残留
			this.registerisShowOness = false;
			this.registerisShowThreess = false;
			this.registermessageText = '';
			this.registernamesmall = '';
			// 第一步：校验是否为空
			if (!this.registername) {
				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title199'); // 原空值提示
			} else {
				const name = this.registername.trim(); // 去除首尾空格（可选，根据业务需求）
				const isLengthValid = name.length >= 6 && name.length <= 12;
				const isFormatValid = /^[a-z][a-z0-9]*$/.test(name);

				// 根据不同条件展示专属提示
				if (!isFormatValid) {
					this.registerisShowOness = true;
					this.registernamesmall = '名稱需以小写字母開頭，且僅包含字母和數字';

				} else if (!isLengthValid) {
					this.registerisShowOness = true;
					// 格式不符合的提示（建议配置多语言，这里先写示例）
					this.registernamesmall = this.$t('indexTitle.title199')
				} else {
					// 所有条件都满足
					this.registerisShowOness = false;
					this.registerisShowThreess = false;
					this.registermessageText = '';
				}
			}
		},
		registerrealnameInput() {
			if (!this.registerrealname) {
				this.registerisShowfivess = true;
				this.registerrealnamesmall = this.$t('indexTitle.title286');
			} else {
				this.registerisShowfivess = false;
				this.registerisShowThreess = false;
				this.registermessageText = '';
			}
		},
		registertikuanpsgInput() {
			this.registertikuanpsg = this.registertikuanpsg.substring(0, 6);
			if (this.registertikuanpsg && this.registertikuanpsg.length < 6) {
				this.registerisShowsixss = true;
				this.registertikuanpsgsmall = this.$t('indexTitle.title298');
				this.registerisloadingTowShow = false;
				// this.$message.error('账号最少6位');
				return false
			}
			if (!this.registertikuanpsg) {
				this.registerisShowsixss = true;
				this.registertikuanpsgsmall = this.$t('indexTitle.title298');
			} else {
				this.registerisShowsixss = false;
				this.registerisShowThreess = false;
				this.registermessageText = '';
			}
		},
		registerpasswordInput() {
			if (this.registerpassword.length < 6) {
				this.registerisShowTowss = true;
				this.registerpsdsamll = '密碼最少6位';
			} else {
				this.registerisShowTowss = false;
				this.registerisShowThreess = false;
				this.registermessageText = '';
			}
		},
		registerphoneInput() {
			if (!this.registerphone) {
				this.registerisShowFourss = true;
				this.registerphonesamll = this.$t('indexTitle.title206');
			} else {
				this.registerisShowFourss = false;
				this.registerisShowThreess = false;
				this.registermessageText = '';
			}
		},
		registersend() {
			if (this.registerok != 1 || this.registertime) {
				return false;
			}
			if (this.registername == '') {
				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title199');
				this.isloadingTowShow = false;
				// this.$message.error('请输入帐号');
				return false
			}

			if (this.registerpassword == '') {
				// this.registerisShowTowss = true;
				// this.registerpsdsamll = this.$t('indexTitle.title59');
				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title59');
				this.isloadingTowShow = false;
				// this.$message.error('请输入密码');
				return false
			}
			if (this.registerrealname == '') {
				// this.registerisShowfivess = true;
				// this.registerrealnamesmall = this.$t('indexTitle.title286');

				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title286');
				this.isloadingTowShow = false;
				// this.$message.error('请输入真实姓名');
				return false
			}
			if (this.registerphone == '') {
				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title206');
				this.isloadingTowShow = false;
				return false
			}
			if (this.needHcaptcha) {
				this.hcaptchaShow('register');
			} else {
				this.registersendExec();
			}
		},
		registersendExec() {
			if (this.needHcaptcha && !this.hcaptchaToken) {
				this.$message({
					showClose: true,
					message: '請完成驗證碼驗證',
					type: "error",
				});
				return false
			}
			let data = {
				phone: this.registerphone,
				type:1,
				hcaptchaToken: this.hcaptchaToken,
			}
			this.registerok = 0;
			sendmsg(data).then((res) => {
				this.registerok = 1;
				this.isloadingTowShow = false;
				this.hcaptchaToken = '';
				if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
				if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
				if (res.status.errorCode == 0) {
					this.registerisShowOness = false;
					this.needHcaptcha = false;
					this.registercountLastTime();
				} else if (res.data === 1) {
					this.needHcaptcha = true;
					this.hcaptchaShow('register');
				} else {
					this.registerisShowOness = true;
					this.registernamesmall = res.status.msg;
					return false
				}
			}).catch((err) => {
				this.registerok = 1;
				this.isloadingTowShow = false;
				this.hcaptchaToken = '';
				if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
				if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
				clearInterval(this.registertimer);
			});
		},
		registercountLastTime() {
			if (!this.registertime) {
					this.registertime = this.registercountTime;
					this.registertime--;
				}
			this.registertimer = setInterval(() => {
				if (!this.registertime) {
					this.registertime = this.registercountTime;
					return;
				}
				this.registertime--;
				if (this.registertime <= 0) {
					clearInterval(this.registertimer);
					this.registertime = 0;
				}
			}, 1000);
		},
		registercodeInput() {
			if (!this.registercode) {
				this.registerisShowcode = true;
				this.registercodesamll = '請輸入驗證碼';
			} else {
				this.registerisShowcode = false;
				this.registerisShowThreess = false;
				this.registermessageText = '';
			}
		},
		registers() {
			let that = this;
			this.isloadingTowShow = true;
			this.registerisShowOness = false;
			this.registerisShowTowss = false;
			this.registerisShowFourss = false;
			this.registerisShowfivess = false;
			this.registerisShowsixss = false;
			this.registerisShowcode = false;
			this.registeraskhdk = false;
			if (this.registername == '') {
				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title199');
				this.isloadingTowShow = false;
				// this.$message.error('请输入帐号');
				return false
			}
			// if (this.registername && this.registername.length < 6) {
			// 	this.registerisShowOness = true;
			// 	this.registernamesmall = this.$t('indexTitle.title199');
			// 	this.isloadingTowShow = false;
			// 	// this.$message.error('账号最少6位');
			// 	return false
			// }

			if (this.registerpassword == '') {
				// this.registerisShowTowss = true;
				// this.registerpsdsamll = this.$t('indexTitle.title59');
				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title59');
				this.isloadingTowShow = false;
				// this.$message.error('请输入密码');
				return false
			}
			if (this.registerrealname == '') {
				// this.registerisShowfivess = true;
				// this.registerrealnamesmall = this.$t('indexTitle.title286');

				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title286');
				this.isloadingTowShow = false;
				// this.$message.error('请输入真实姓名');
				return false
			}
			if (this.registerphone == '') {
				// this.registerisShowFourss = true;
				// this.registerphonesamll = this.$t('indexTitle.title206');

				this.registerisShowOness = true;
				this.registernamesmall = this.$t('indexTitle.title206');
				this.isloadingTowShow = false;
				// this.$message.error('请输入手机号');
				return false
			}
			if (this.registercode == '') {
				this.registerisShowOness = true;
				this.registernamesmall = '請輸入驗證碼';
				this.isloadingTowShow = false;
				return false
			}
			// if (this.registertikuanpsg == '') {
			// 	// this.registerisShowsixss = true;
			// 	// this.registertikuanpsgsmall = this.$t('indexTitle.title298');

			// 	this.registerisShowOness = true;
			// 	this.registernamesmall = this.$t('indexTitle.title298');
			// 	this.isloadingTowShow = false;
			// 	// this.$message.error('请输入提款密码');
			// 	return false
			// }
			// if (this.registertikuanpsg && this.registertikuanpsg.length < 6) {
			// 	// this.registerisShowsixss = true;
			// 	// this.registertikuanpsgsmall = this.$t('indexTitle.title298');

			// 	this.registerisShowOness = true;
			// 	this.registernamesmall = this.$t('indexTitle.title298');
			// 	this.isloadingTowShow = false;
			// 	// this.$message.error('账号最少6位');
			// 	return false
			// }

			let data = {
				name: this.registername,
				password: this.registerpassword,
				real_name: this.registerrealname,
				phone: this.registerphone,
				qk_pwd: this.registertikuanpsg,
				code: this.registercode,
				i_code: localStorage.getItem('invite_code'),
			}
			register(data).then((res) => {
				if (res.status.errorCode == 0) {
					// this.$message.success(res.status.msg);
					this.$message({
						type: 'success', // 对应 success 类型
						message: res.status.msg,
						showClose: true, // 核心：显示关闭按钮
						duration: 1500, // 可选：5秒后自动关闭（0=永不自动关闭）
					})
					let data = {
						name: this.registername,
						password: this.registerpassword
					}
					login(data).then((res) => {
						if (res.status.errorCode == 0) {
							// this.$message.success(res.status.msg);
							this.token = res.data
							localStorage.removeItem('userInfo')
							localStorage.setItem('token', res.data)
							this.$bus.$emit('syncGamePlayHistory')
							// if(this.activitId){
							localStorage.setItem('nameNum', this.name)
							localStorage.setItem('passwordNum', this.password)
							// }else{
							// 	localStorage.setItem('nameNum', '')
							// 	localStorage.setItem('passwordNum', '')
							// }
							this.getuserinfo()
							this.name = '';
							this.loginphone = '';
							this.password = '';
							this.registerShow = false;
							// setTimeout(function() {
							// 	location.reload()
							// 	that.$router.push('/index')
							// 	that.isloadingTowShow = false;
							// }, 1000)
						} else {
							this.isShowThreess = true;
							this.isloadingTowShow = false;
							this.hcaptchaToken = '';
							if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
							if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
							this.messageText = res.status.msg;
							// this.$message.error(res.status.msg);
						}
					}).catch((err) => {
						this.isloadingTowShow = false;
						this.hcaptchaToken = '';
						if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
						if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
						console.log(err, 'err')
					});
				} else {
					this.isloadingTowShow = false;
					this.hcaptchaToken = '';
					if (this.$refs.hcaptchaMobile) this.$refs.hcaptchaMobile.reset();
					if (this.$refs.hcaptchaDesktop) this.$refs.hcaptchaDesktop.reset();
					this.registerisShowThreess = true;
					this.registermessageText = res.status.msg;
					// this.$message.error(res.status.msg);
				}
			}).catch((err) => {
				this.isloadingTowShow = false;
				console.log(err, 'err')
			});
		},
		//注册相关结束
		//注册相关结束
		loginOut() {
			localStorage.removeItem('token');
			localStorage.removeItem('siteTitle');
			localStorage.removeItem('siteIco');
			if (localStorage.getItem('languageTow')) {
				localStorage.removeItem('languageTow');
			}
			if (localStorage.getItem('language')) {
				localStorage.removeItem('language');
			}
			if (localStorage.getItem('userInfo')) {
				localStorage.removeItem('userInfo');
			}
			if (localStorage.getItem('tongjilistTow')) {
				localStorage.removeItem('tongjilistTow');
			}
			document.body.classList.remove('is-logged-in')
			this.$bus.$emit('syncGamePlayHistory')
			this.$bus.$emit('refreshUserInfo')
			location.href = "/"
			// this.$router.push('/login')
		},
		//平台公告
		personalMsg(num = 0) {
			this.msgtab = num;
			this.getNoticeList();
			this.msgshow = true;
		},
		getNoticeList() {
			this.noticeList = [];
			let that = this;
			let data = {}
			noticeList(data).then((res) => {
				if (res.status.errorCode == 0) {
					console.log(res.data.data);
					this.noticeList = res.data.data;
				} else {
					// this.$message.error(res.status.msg);
					this.msgTextTow = res.status.msg;
					this.isShowLoadingTeow = true;
					setTimeout(() => {
						this.isShowLoadingTeow = false;
					}, 2000)
					// this.$message({
					// 	showClose: true,
					// 	message: res.status.msg,
					// 	type: 'error'
					// });
				}
			}).catch((err) => {
				console.log(err, 'err')
			});
		},
		changetab(e) {
			this.tab = e
			this.showloading = true;
			this.getNoticeList()
			let that = this;
			setTimeout(function () {
				that.showloading = false
			}, 3000)
		},
		//平台公告结束
		switchLang(lang) {
			if (lang == 'zh') {
				localStorage.setItem("languageTow", 'zh_cn');
			} else if (lang == 'th') {
				localStorage.setItem("languageTow", 'th');
			} else {
				localStorage.setItem("languageTow", lang);
			}
			this.$i18n.locale = lang;
			localStorage.setItem("language", lang);
			this.langshow = false;
		},
	},
	computed: {
		siteName() {
			const name = (this.systemconfig && this.systemconfig.site_name) || ''
			return String(name).trim() || 'U66888'
		},
		siteLogoUrl() {
			const raw = (this.systemconfig && this.systemconfig.m_site_logo) || ''
			return resolveMediaUrl(raw)
		},
		currentLangFlag() {
			const map = {
				en: require('@/assets/newimg/US.png'),
				th: require('@/assets/newimg/TH.png'),
				zh: require('@/assets/newimg/CN.png'),
				ft: require('@/assets/newimg/CN.png'),
			}
			return map[this.$i18n.locale] || map.th
		}
	}
}
</script>

<style scoped>
/* 头部 */
.HomeTop {
	width: 100%;
	height: 50px;
	position: fixed;
	top: 0;
	left: 0;
	background-color: #1a1a1a;
	border: 1px solid #1a1a1a;
	display: flex;
	align-items: center;
	padding: 0px 15px;
	z-index: 99;
	box-sizing: border-box;
	justify-content: space-between;
}

.logoImg {
	width: 80px;
	height: 33px;
}

.logoImg img {
	height: 100%;
}

.rightBox {
	display: flex;
	align-items: center;
	position: relative;
}

.yueBox {
	position: absolute;
	width: 250px;
	/* border: 1px solid #eee; */
	background: linear-gradient(#363636, #292929, #1b1b1c);
	font-size: 13px;
	color: #fff;
	top: 30px;
	right: -5px;
	border-radius: 5px;
}

.yuenum {
	width: 100%;
	height: 30px;
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	color: #fff;
	font-size: 23px;
	font-weight: 600;
	padding-right: 10px;
	box-sizing: border-box;
}

.ssssxuanzhuan {
	animation: rotatefresh 1s;
}

@keyframes rotatefresh {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
		transition: all 0.6s;
	}
}

.yuenum img {
	width: 20px;
	height: 20px;
	margin-left: 5px;
}

.yuenav {
	width: 100%;
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #fff;
	font-size: 15px;
}

.yuenavIt {
	width: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.yuenavIt img {
	width: 26px;
	height: 26px;
	margin-right: 8px;
}

.yuenavIt:first-child {
	border-right: 1px solid #5e5e5e;
}

.langBox {
	position: absolute;
	width: 110px;
	border: 1px solid #eee;
	background-color: #2f2f2f;
	font-size: 13px;
	color: #fff;
	top: 30px;
	right: -5px;
	border-radius: 5px;
}

.langItBox {
	width: 100%;
	padding-left: 10px;
	display: flex;
	align-items: center;
	height: 40px;
}

.langItBox img {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	margin-right: 3px;
}

.zhucibox {
	font-size: 13px;
	color: #fff;
	border: 0;
	border-radius: 6px;
	display: flex;
	line-height: 1;
	padding: 8px 12px;
	background: linear-gradient(180deg, #19f0ca, #05c8c6);
}

.denglubox {
	font-size: 13px;
	color: #fff;
	border: 0;
	border-radius: 6px;
	display: flex;
	line-height: 1;
	padding: 8px 12px;
	margin: 0px 5px;
	background: linear-gradient(180deg, #9e4fff, #5235ff);
}

.yidengluBox {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-weight: 700;
	color: #fff;
	margin-right: 5px;
}

.yidengluBox img {
	width: 20px;
	height: 20px;
	margin-right: 5px;
}

.yuyanbox {
	width: 20px;
	height: 20px;
}

.yuyanbox img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}


.wrapper {
	position: fixed;
	width: 100%;
	min-height: 100%;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	z-index: 999999;
	background: #000;
}

iframe {
	width: 100%;
	height: 100%;
	border: 0;
}

.draggable-img {
	pointer-events: auto;
	/* 防止文字选中 */
	-webkit-user-drag: none;
	-khtml-user-drag: none;
	-moz-user-drag: none;
	-o-user-drag: none;
	user-drag: none;
}

.drag-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9999;
	pointer-events: none;
	/* 👈 关键：容器不拦截事件 */
}

.drag-container img {
	pointer-events: auto;
	/* 👈 图片可以响应事件 */
}

.rotate-spin {
	animation: rotate 0.5s linear;
}

@keyframes rotate {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.feature-entries {
	position: relative;
	z-index: 1;
}

.feature-card {
	position: relative;
	border-radius: 14px;
	overflow: hidden;
	cursor: pointer;
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.feature-card:hover {
	transform: translateY(-1px);
}

.feature-card__glow {
	position: absolute;
	top: -20px;
	right: -20px;
	width: 72px;
	height: 72px;
	border-radius: 50%;
	opacity: 0.45;
	pointer-events: none;
}

.feature-card--bonus {
	background: linear-gradient(135deg, #3d2a6e 0%, #5c3d9e 45%, #7b4fc4 100%);
	box-shadow: 0 4px 16px rgba(123, 79, 196, 0.35);
}

.feature-card--bonus .feature-card__glow {
	background: radial-gradient(circle, #ffd86b 0%, transparent 70%);
}

.feature-card--yuebao {
	background: linear-gradient(135deg, #0a4d4a 0%, #0d6b5f 45%, #00a88a 100%);
	box-shadow: 0 4px 16px rgba(0, 221, 184, 0.3);
}

.feature-card--yuebao .feature-card__glow {
	background: radial-gradient(circle, #4dffff 0%, transparent 70%);
}

.feature-card__body {
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	padding: 12px 10px 12px 12px;
	min-height: 72px;
}

.feature-card__icon {
	flex-shrink: 0;
	width: 40px;
	height: 40px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 8px;
}

.feature-card__icon img {
	width: 22px;
	height: 22px;
}

.feature-card__icon--bonus {
	background: rgba(255, 216, 107, 0.2);
	border: 1px solid rgba(255, 216, 107, 0.35);
}

.feature-card__icon--yuebao {
	background: rgba(77, 255, 255, 0.15);
	border: 1px solid rgba(77, 255, 255, 0.3);
	color: #4dffff;
}

.feature-card__icon--yuebao svg {
	width: 22px;
	height: 22px;
}

.feature-card__text {
	flex: 1;
	min-width: 0;
}

.feature-card__title {
	font-size: 14px;
	font-weight: 600;
	color: #fff;
	line-height: 1.3;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.feature-card__desc {
	font-size: 11px;
	color: rgba(255, 255, 255, 0.65);
	margin-top: 3px;
	line-height: 1.3;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.feature-card__arrow {
	flex-shrink: 0;
	width: 20px;
	height: 20px;
	color: rgba(255, 255, 255, 0.5);
	margin-left: 2px;
}

.mp-balance-pill {
	display: flex;
	align-items: center;
	gap: 5px;
	min-width: 0;
	max-width: 42vw;
	height: 34px;
	padding: 0 6px 0 8px;
	border-radius: 999px;
	background: rgba(0, 12, 32, 0.55);
	border: 1px solid rgba(255, 255, 255, 0.18);
	box-shadow: inset 0 0 0 1px rgba(63, 170, 252, 0.12);
	cursor: pointer;
}
.mp-balance-pill__coin {
	width: 18px;
	height: 18px;
	flex-shrink: 0;
	object-fit: contain;
	display: block;
}
.mp-balance-pill__amt {
	color: #fff;
	font-size: 13px;
	font-weight: 700;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
}
.mp-balance-pill__refresh {
	width: 22px;
	height: 22px;
	border: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.08);
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	flex-shrink: 0;
}
.mp-balance-pill__refresh .mdi {
	font-size: 16px;
	line-height: 1;
}
.mp-menu-btn {
	width: 34px;
	height: 34px;
	border-radius: 8px;
	border: 1px solid rgba(255, 255, 255, 0.35);
	background: transparent;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4px;
	padding: 0;
	flex-shrink: 0;
}
.mp-menu-btn span {
	display: block;
	width: 14px;
	height: 2px;
	background: #fff;
	border-radius: 1px;
}
.mp-brand {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	user-select: none;
	max-width: 42vw;
	overflow: hidden;
	flex-shrink: 1;
	min-width: 0;
	line-height: 0;
}
.mp-brand__logo {
	display: block;
	height: 32px;
	width: auto;
	max-width: 100%;
	object-fit: contain;
}
.mp-flag-btn {
	width: 34px;
	height: 34px;
	border: 0;
	padding: 0;
	border-radius: 50%;
	overflow: hidden;
	background: transparent;
}
.mp-flag-btn img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 50%;
}

.mp-lang-mask {
	position: fixed;
	inset: 0;
	z-index: 2000;
	background: rgba(0, 0, 0, 0.62);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}
.mp-lang-modal {
	width: min(340px, 100%);
	border-radius: 18px;
	overflow: hidden;
	background: #1a1a1a;
	box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}
.mp-lang-modal__head {
	position: relative;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--mp-gradient-cta-reg);
	color: #fff;
	font-size: 17px;
	font-weight: 700;
}
.mp-lang-modal__close {
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	border: 0;
	background: transparent;
	color: #fff;
	font-size: 28px;
	line-height: 1;
	padding: 0 4px;
	cursor: pointer;
}
.mp-lang-modal__body {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px;
	padding: 18px 14px 20px;
	background: #151515;
}
.mp-lang-tile {
	position: relative;
	border: 1px solid #2a2a2a;
	background: #222;
	border-radius: 14px;
	padding: 14px 6px 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	color: #fff;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	min-height: 104px;
}
.mp-lang-tile img {
	width: 42px;
	height: 42px;
	border-radius: 50%;
	object-fit: cover;
}
.mp-lang-tile.is-active {
	border-color: var(--mp-orange, #f87171);
	box-shadow: 0 0 0 1px rgba(251, 113, 133, 0.55), 0 0 12px rgba(244, 63, 94, 0.35);
}
.mp-lang-tile__check {
	position: absolute;
	top: 6px;
	right: 6px;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: var(--mp-orange, #f87171);
	color: #fff;
	font-size: 11px;
	font-weight: 800;
	line-height: 18px;
	text-align: center;
}

/* PC 顶栏（截图布局 + 蓝主题，不影响手机） */
.mp-pc-balance,
.mp-pc-btn,
.mp-pc-left,
.mp-pc-right,
.mp-pc-nav,
.mp-pc-brand,
.mp-pc-flag,
.mp-pc-hamburger {
	display: none;
}
@media (min-width: 1024px) {
	#header .mp-topbar,
	#header .mp-topbar-guest {
		background: linear-gradient(
			180deg,
			#3faafc 0%,
			#2575fc 22%,
			#1348a8 52%,
			#0a1e44 78%,
			#000b1d 100%
		) !important;
		border-bottom: 0;
		box-shadow: 0 4px 18px rgba(29, 111, 232, 0.28);
	}
	.mp-topbar__inner {
		width: 100%;
		max-width: 1280px;
		margin: 0 auto;
		padding: 0 24px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		height: 100%;
	}
	.mp-pc-left,
	.mp-pc-right {
		display: flex;
		align-items: center;
		min-width: 0;
	}
	.mp-pc-left {
		gap: 18px;
		flex: 1;
	}
	.mp-pc-right {
		gap: 10px;
		flex-shrink: 0;
		position: relative;
	}
	.mp-pc-brand {
		display: inline-flex;
		align-items: center;
		border: 0;
		background: transparent;
		cursor: pointer;
		padding: 0;
		line-height: 0;
		max-width: 220px;
	}
	.mp-pc-brand__logo {
		display: block;
		height: 44px;
		width: auto;
		max-width: 100%;
		object-fit: contain;
	}
	.mp-pc-nav {
		display: flex;
		align-items: center;
		gap: 6px;
		min-width: 0;
		overflow-x: auto;
		scrollbar-width: none;
	}
	.mp-pc-nav::-webkit-scrollbar {
		display: none;
	}
	.mp-pc-nav__item {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		height: 36px;
		padding: 0 12px;
		border: 0;
		border-radius: 10px;
		background: transparent;
		color: #fff;
		font-size: 14px;
		font-weight: 700;
		cursor: pointer;
		white-space: nowrap;
		opacity: 0.92;
	}
	.mp-pc-nav__item:hover,
	.mp-pc-nav__item.is-active {
		background: rgba(0, 0, 0, 0.28);
		opacity: 1;
	}
	.mp-pc-nav__ico {
		width: 16px;
		height: 16px;
		flex-shrink: 0;
	}
	.mp-pc-flag {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 34px;
		height: 34px;
		border: 0;
		border-radius: 50%;
		padding: 0;
		background: rgba(0, 0, 0, 0.18);
		cursor: pointer;
		overflow: hidden;
		flex-shrink: 0;
	}
	.mp-pc-flag img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.mp-pc-balance {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		height: 40px;
		padding: 0 10px 0 12px;
		border-radius: 999px;
		background: rgba(0, 11, 29, 0.45);
		border: 1px solid rgba(255, 255, 255, 0.12);
		min-width: 120px;
	}
	.mp-pc-balance__refresh {
		border: 0;
		background: transparent;
		color: #fff;
		padding: 0;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
	}
	.mp-pc-balance__coin {
		width: 20px;
		height: 20px;
		display: block;
		flex-shrink: 0;
	}
	.mp-pc-balance__amt {
		font-size: 15px;
		font-weight: 700;
		color: #fff;
		white-space: nowrap;
		flex: 1;
	}
	.mp-pc-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		height: 40px;
		padding: 0 16px;
		border-radius: 10px;
		font-size: 14px;
		font-weight: 800;
		cursor: pointer;
		white-space: nowrap;
		border: 0;
		color: #fff;
	}
	.mp-pc-btn svg {
		width: 16px;
		height: 16px;
		flex-shrink: 0;
	}
	.mp-pc-btn--deposit {
		background: linear-gradient(180deg, #5ec8ff 0%, #3faafc 45%, #1d6fe8 100%);
		box-shadow: 0 6px 14px rgba(29, 111, 232, 0.35);
	}
	.mp-pc-btn--withdraw {
		background: linear-gradient(180deg, #8ad8ff 0%, #5ec8ff 50%, #3faafc 100%);
		box-shadow: 0 6px 14px rgba(63, 170, 252, 0.28);
	}
	.mp-pc-btn--ghost {
		background: rgba(0, 0, 0, 0.28);
		border: 1.5px solid rgba(255, 255, 255, 0.35);
	}
	.mp-pc-menu-wrap {
		position: relative;
		display: inline-flex;
		align-items: center;
	}
	.mp-pc-hamburger {
		display: inline-flex;
		flex-direction: column;
		justify-content: center;
		gap: 5px;
		width: 36px;
		height: 36px;
		padding: 0 7px;
		border: 0;
		background: transparent;
		cursor: pointer;
	}
	.mp-pc-hamburger span {
		display: block;
		height: 2.5px;
		width: 100%;
		border-radius: 2px;
		background: #fff;
	}
}
</style>
